/**
 *  2.1
 *
 *  2.2 jQuery.appear
 *
 *  2.3  jQuery Easing v1.3
 *
 *  2.4 jQuery Cookie Plugin v1.4.1
 *
 *  3. Bootstrap v4.0.0-beta.3
 *
 *  4. common
 *
 *  5. jquery.validation.js
 *
 *  6. jquery.stellar.js
 *
 *  7. jquery.easy-pie-chart.js
 *
 *  8. jquery.gmap.js
 *
 *  9. jquery.isotope.js
 *
 *  10. owl.carousel.js
 *
 *  11. jflickrfeed.js
 *
 *  12. jquery.magnific-popup.js
 *
 *  13. vide.js
 *
 *  14. theme.js
 *
 *  15. jquery.themepunch.tools.min.js
 *
 *  16. jquery.themepunch.revolution.min.js
 *
 *  17. jquery.flipshow.js
 *
 * *
 *  18. view.home
 *
 **/

/* ==========================================================================
   2.1

/* ==========================================================================
   2.2 jquery.appear.js
/*
 * jQuery.appear
 * https://github.com/bas2k/jquery.appear/
 * http://code.google.com/p/jquery-appear/
 * http://bas2k.ru/
 *
 * Copyright (c) 2009 Michael Hixson
 * Copyright (c) 2012-2014 Alexander Brovikov
 * Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
 */

(function($) {
  $.fn.appear = function(fn, options) {

    var settings = $.extend({

      //arbitrary data to pass to fn
      data: undefined,

      //call fn only on the first appear?
      one: true,

      // X & Y accuracy
      accX: 0,
      accY: 0

    }, options);

    return this.each(function() {

      var t = $(this);

      //whether the element is currently visible
      t.appeared = false;

      if (!fn) {

        //trigger the custom event
        t.trigger('appear', settings.data);
        return;
      }

      var w = $(window);

      //fires the appear event when appropriate
      var check = function() {

        //is the element hidden?
        if (!t.is(':visible')) {

          //it became hidden
          t.appeared = false;
          return;
        }

        //is the element inside the visible window?
        var a = w.scrollLeft();
        var b = w.scrollTop();
        var o = t.offset();
        var x = o.left;
        var y = o.top;

        var ax = settings.accX;
        var ay = settings.accY;
        var th = t.height();
        var wh = w.height();
        var tw = t.width();
        var ww = w.width();

        if (y + th + ay >= b &&
          y <= b + wh + ay &&
          x + tw + ax >= a &&
          x <= a + ww + ax) {

          //trigger the custom event
          if (!t.appeared) t.trigger('appear', settings.data);

        } else {

          //it scrolled out of view
          t.appeared = false;
        }
      };

      //create a modified fn with some additional logic
      var modifiedFn = function() {

        //mark the element as visible
        t.appeared = true;

        //is this supposed to happen only once?
        if (settings.one) {

          //remove the check
          w.unbind('scroll', check);
          var i = $.inArray(check, $.fn.appear.checks);
          if (i >= 0) $.fn.appear.checks.splice(i, 1);
        }

        //trigger the original fn
        fn.apply(this, arguments);
      };

      //bind the modified fn to the element
      if (settings.one) t.one('appear', settings.data, modifiedFn);
      else t.bind('appear', settings.data, modifiedFn);

      //check whenever the window scrolls
      w.scroll(check);

      //check whenever the dom changes
      $.fn.appear.checks.push(check);

      //check now
      (check)();
    });
  };

  //keep a queue of appearance checks
  $.extend($.fn.appear, {

    checks: [],
    timeout: null,

    //process the queue
    checkAll: function() {
      var length = $.fn.appear.checks.length;
      if (length > 0) while (length--) ($.fn.appear.checks[length])();
    },

    //check the queue asynchronously
    run: function() {
      if ($.fn.appear.timeout) clearTimeout($.fn.appear.timeout);
      $.fn.appear.timeout = setTimeout($.fn.appear.checkAll, 20);
    }
  });

  //run checks when these methods are called
  $.each(['append', 'prepend', 'after', 'before', 'attr',
    'removeAttr', 'addClass', 'removeClass', 'toggleClass',
    'remove', 'css', 'show', 'hide'], function(i, n) {
    var old = $.fn[n];
    if (old) {
      $.fn[n] = function() {
        var r = old.apply(this, arguments);
        $.fn.appear.run();
        return r;
      }
    }
  });

})(jQuery);

/* ==========================================================================
   2.3
/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright В© 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
  {
    def: 'easeOutQuad',
    swing: function (x, t, b, c, d) {
      //alert(jQuery.easing.default);
      return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
    },
    easeInQuad: function (x, t, b, c, d) {
      return c*(t/=d)*t + b;
    },
    easeOutQuad: function (x, t, b, c, d) {
      return -c *(t/=d)*(t-2) + b;
    },
    easeInOutQuad: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t + b;
      return -c/2 * ((--t)*(t-2) - 1) + b;
    },
    easeInCubic: function (x, t, b, c, d) {
      return c*(t/=d)*t*t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t + 1) + b;
    },
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t + b;
      return c/2*((t-=2)*t*t + 2) + b;
    },
    easeInQuart: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t + b;
    },
    easeOutQuart: function (x, t, b, c, d) {
      return -c * ((t=t/d-1)*t*t*t - 1) + b;
    },
    easeInOutQuart: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
      return -c/2 * ((t-=2)*t*t*t - 2) + b;
    },
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    },
    easeInSine: function (x, t, b, c, d) {
      return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
    },
    easeOutSine: function (x, t, b, c, d) {
      return c * Math.sin(t/d * (Math.PI/2)) + b;
    },
    easeInOutSine: function (x, t, b, c, d) {
      return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
    },
    easeInExpo: function (x, t, b, c, d) {
      return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
    },
    easeOutExpo: function (x, t, b, c, d) {
      return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
    },
    easeInOutExpo: function (x, t, b, c, d) {
      if (t==0) return b;
      if (t==d) return b+c;
      if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
      return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
    easeInCirc: function (x, t, b, c, d) {
      return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
    },
    easeOutCirc: function (x, t, b, c, d) {
      return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
    },
    easeInOutCirc: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
      return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
    },
    easeInElastic: function (x, t, b, c, d) {
      var s=1.70158;var p=0;var a=c;
      if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
      if (a < Math.abs(c)) { a=c; var s=p/4; }
      else var s = p/(2*Math.PI) * Math.asin (c/a);
      return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
    },
    easeOutElastic: function (x, t, b, c, d) {
      var s=1.70158;var p=0;var a=c;
      if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
      if (a < Math.abs(c)) { a=c; var s=p/4; }
      else var s = p/(2*Math.PI) * Math.asin (c/a);
      return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
    },
    easeInOutElastic: function (x, t, b, c, d) {
      var s=1.70158;var p=0;var a=c;
      if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
      if (a < Math.abs(c)) { a=c; var s=p/4; }
      else var s = p/(2*Math.PI) * Math.asin (c/a);
      if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
      return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
    },
    easeInBack: function (x, t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c*(t/=d)*t*((s+1)*t - s) + b;
    },
    easeOutBack: function (x, t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
    },
    easeInOutBack: function (x, t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
      return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
    },
    easeInBounce: function (x, t, b, c, d) {
      return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
    },
    easeOutBounce: function (x, t, b, c, d) {
      if ((t/=d) < (1/2.75)) {
        return c*(7.5625*t*t) + b;
      } else if (t < (2/2.75)) {
        return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
      } else if (t < (2.5/2.75)) {
        return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
      } else {
        return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
      }
    },
    easeInOutBounce: function (x, t, b, c, d) {
      if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
      return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
    }
  });

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 *
 * Open source under the BSD License.
 *
 * Copyright В© 2001 Robert Penner
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */
;

/* ==========================================================================
   2.4
/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function ($) {

  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch(e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = $.cookie = function (key, value, options) {

    // Write

    if (value !== undefined && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires, t = options.expires = new Date();
        t.setTime(+t + days * 864e+5);
      }

      return (document.cookie = [
        encode(key), '=', stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path	? '; path=' + options.path : '',
        options.domain  ? '; domain=' + options.domain : '',
        options.secure  ? '; secure' : ''
      ].join(''));
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling $.cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i++) {
      var parts = cookies[i].split('=');
      var name = decode(parts.shift());
      var cookie = parts.join('=');

      if (key && key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  };

  config.defaults = {};

  $.removeCookie = function (key, options) {
    if ($.cookie(key) === undefined) {
      return false;
    }

    // Must not alter options, thus extending a fresh object...
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };

}));

/* ==========================================================================
   4. common
   ========================================================================== */
!function (a) {
  return false;
  a.extend({
    browserSelector: function () {
      !function (a) {
        (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
      }(navigator.userAgent || navigator.vendor || window.opera);
      var b = navigator.userAgent, d = b.toLowerCase(), e = function (a) {
          return d.indexOf(a) > -1
        }, f = "gecko", g = "webkit", h = "safari", i = "opera", j = document.documentElement,
        k = [!/opera|webtv/i.test(d) && /msie\s(\d)/.test(d) ? "ie ie" + parseFloat(navigator.appVersion.split("MSIE")[1]) : e("firefox/2") ? f + " ff2" : e("firefox/3.5") ? f + " ff3 ff3_5" : e("firefox/3") ? f + " ff3" : e("gecko/") ? f : e("opera") ? i + (/version\/(\d+)/.test(d) ? " " + i + RegExp.jQuery1 : /opera(\s|\/)(\d+)/.test(d) ? " " + i + RegExp.jQuery2 : "") : e("konqueror") ? "konqueror" : e("chrome") ? g + " chrome" : e("iron") ? g + " iron" : e("applewebkit/") ? g + " " + h + (/version\/(\d+)/.test(d) ? " " + h + RegExp.jQuery1 : "") : e("mozilla/") ? f : "", e("j2me") ? "mobile" : e("iphone") ? "iphone" : e("ipod") ? "ipod" : e("mac") ? "mac" : e("darwin") ? "mac" : e("webtv") ? "webtv" : e("win") ? "win" : e("freebsd") ? "freebsd" : e("x11") || e("linux") ? "linux" : "", "js"];
      c = k.join(" "), a.browser.mobile && (c += " mobile"), j.className += " " + c;
      var l = !window.ActiveXObject && "ActiveXObject" in window;
      return l ? void a("html").removeClass("gecko").addClass("ie ie11") : (a("body").hasClass("dark") && a("html").addClass("dark"), void(a("body").hasClass("boxed") && a("html").addClass("boxed")))
    }
  }), a.browserSelector()
}(jQuery), function (a) {
  return false;
  var b = "waitForImages";
  a.waitForImages = {hasImageProperties: ["backgroundImage", "listStyleImage", "borderImage", "borderCornerImage", "cursor"]}, a.expr[":"].uncached = function (b) {
    if (!a(b).is('img[src][src!=""]')) return !1;
    var c = new Image;
    return c.src = b.src, !c.complete
  }, a.fn.waitForImages = function (c, d, e) {
    var f = 0, g = 0;
    if (a.isPlainObject(arguments[0]) && (e = arguments[0].waitForAll, d = arguments[0].each, c = arguments[0].finished), c = c || a.noop, d = d || a.noop, e = !!e, !a.isFunction(c) || !a.isFunction(d)) throw new TypeError("An invalid callback was supplied.");
    return this.each(function () {
      var h = a(this), i = [], j = a.waitForImages.hasImageProperties || [],
        k = /url\(\s*(['"]?)(.*?)\1\s*\)/g;
      e ? h.find("*").addBack().each(function () {
        var b = a(this);
        b.is("img:uncached") && i.push({
          src: b.attr("src"),
          element: b[0]
        }), a.each(j, function (a, c) {
          var d, e = b.css(c);
          if (!e) return !0;
          for (; d = k.exec(e);) i.push({src: d[2], element: b[0]})
        })
      }) : h.find("img:uncached").each(function () {
        i.push({src: this.src, element: this})
      }), f = i.length, g = 0, 0 === f && c.call(h[0]), a.each(i, function (e, i) {
        var j = new Image, k = "load." + b + " error." + b;
        a(j).on(k, function l(b) {
          return g++, d.call(i.element, g, f, "load" == b.type), a(this).off(k, l), g == f ? (c.call(h[0]), !1) : void 0
        }), j.src = i.src
      })
    })
  }
}(jQuery), function (a) {
  function b(a, b) {
    return a.toFixed(b.decimals)
  }

  a.fn.countTo = function (b) {
    return b = b || {}, a(this).each(function () {
      function c() {
        k += g, j++, d(k), "function" == typeof e.onUpdate && e.onUpdate.call(h, k), j >= f && (i.removeData("countTo"), clearInterval(l.interval), k = e.to, "function" == typeof e.onComplete && e.onComplete.call(h, k))
      }

      function d(a) {
        var b = e.formatter.call(h, a, e);
        i.html(b)
      }

      var e = a.extend({}, a.fn.countTo.defaults, {
          from: a(this).data("from"),
          to: a(this).data("to"),
          speed: a(this).data("speed"),
          refreshInterval: a(this).data("refresh-interval"),
          decimals: a(this).data("decimals")
        }, b), f = Math.ceil(e.speed / e.refreshInterval), g = (e.to - e.from) / f, h = this,
        i = a(this), j = 0, k = e.from, l = i.data("countTo") || {};
      i.data("countTo", l), l.interval && clearInterval(l.interval), l.interval = setInterval(c, e.refreshInterval), d(k)
    })
  }, a.fn.countTo.defaults = {
    from: 0,
    to: 0,
    speed: 1e3,
    refreshInterval: 100,
    decimals: 0,
    formatter: b,
    onUpdate: null,
    onComplete: null
  }
}(jQuery), function (a) {
  "use strict";
  var b, c = {
    action: function () {
    }, runOnLoad: !1, duration: 500
  }, d = c, e = !1, f = {};
  f.init = function () {
    for (var b = 0; b <= arguments.length; b++) {
      var c = arguments[b];
      switch (typeof c) {
        case"function":
          d.action = c;
          break;
        case"boolean":
          d.runOnLoad = c;
          break;
        case"number":
          d.duration = c
      }
    }
    return this.each(function () {
      d.runOnLoad && d.action(), a(this).resize(function () {
        f.timedAction.call(this)
      })
    })
  }, f.timedAction = function (a, c) {
    var f = function () {
      var a = d.duration;
      if (e) {
        var c = new Date - b;
        if (a = d.duration - c, 0 >= a) return clearTimeout(e), e = !1, void d.action()
      }
      g(a)
    }, g = function (a) {
      e = setTimeout(f, a)
    };
    b = new Date, "number" == typeof c && (d.duration = c), "function" == typeof a && (d.action = a), e || f()
  }, a.fn.afterResize = function (a) {
    return f[a] ? f[a].apply(this, Array.prototype.slice.call(arguments, 1)) : f.init.apply(this, arguments)
  }
}(jQuery), function (a) {
  a.extend({
    smoothScroll: function () {
      function a() {
        var a = !1;
        if (document.URL.indexOf("google.com/reader/view") > -1 && (a = !0), t.excluded) {
          var b = t.excluded.split(/[,\n] ?/);
          b.push("mail.google.com");
          for (var c = b.length; c--;) if (document.URL.indexOf(b[c]) > -1) {
            r && r.disconnect(), j("mousewheel", d), a = !0, u = !0;
            break
          }
        }
        a && j("keydown", e), t.keyboardSupport && !a && i("keydown", e)
      }

      function b() {
        if (document.body) {
          var b = document.body, c = document.documentElement, d = window.innerHeight,
            e = b.scrollHeight;
          if (y = document.compatMode.indexOf("CSS") >= 0 ? c : b, q = b, a(), x = !0, top != self) v = !0; else if (e > d && (b.offsetHeight <= d || c.offsetHeight <= d)) {
            var f = !1, g = function () {
              f || c.scrollHeight == document.height || (f = !0, setTimeout(function () {
                c.style.height = document.height + "px", f = !1
              }, 500))
            };
            c.style.height = "auto", setTimeout(g, 10);
            var h = {attributes: !0, childList: !0, characterData: !1};
            if (r = new I(g), r.observe(b, h), y.offsetHeight <= d) {
              var i = document.createElement("div");
              i.style.clear = "both", b.appendChild(i)
            }
          }
          if (document.URL.indexOf("mail.google.com") > -1) {
            var j = document.createElement("style");
            j.innerHTML = ".iu { visibility: hidden }", (document.getElementsByTagName("head")[0] || c).appendChild(j)
          } else if (document.URL.indexOf("www.facebook.com") > -1) {
            var k = document.getElementById("home_stream");
            k && (k.style.webkitTransform = "translateZ(0)")
          }
          t.fixedBackground || u || (b.style.backgroundAttachment = "scroll", c.style.backgroundAttachment = "scroll")
        }
      }

      function c(a, b, c, d) {
        if (d || (d = 1e3), l(b, c), 1 != t.accelerationMax) {
          var e = +new Date, f = e - D;
          if (f < t.accelerationDelta) {
            var g = (1 + 30 / f) / 2;
            g > 1 && (g = Math.min(g, t.accelerationMax), b *= g, c *= g)
          }
          D = +new Date
        }
        if (B.push({
          x: b,
          y: c,
          lastX: 0 > b ? .99 : -.99,
          lastY: 0 > c ? .99 : -.99,
          start: +new Date
        }), !C) {
          var h = a === document.body, i = function () {
            for (var e = +new Date, f = 0, g = 0, j = 0; j < B.length; j++) {
              var k = B[j], l = e - k.start, m = l >= t.animationTime,
                n = m ? 1 : l / t.animationTime;
              t.pulseAlgorithm && (n = p(n));
              var o = k.x * n - k.lastX >> 0, q = k.y * n - k.lastY >> 0;
              f += o, g += q, k.lastX += o, k.lastY += q, m && (B.splice(j, 1), j--)
            }
            h ? window.scrollBy(f, g) : (f && (a.scrollLeft += f), g && (a.scrollTop += g)), b || c || (B = []), B.length ? H(i, a, d / t.frameRate + 1) : C = !1
          };
          H(i, a, 0), C = !0
        }
      }

      function d(a) {
        x || b();
        var d = a.target, e = h(d);
        if (!e || a.defaultPrevented || k(q, "embed") || k(d, "embed") && /\.pdf/i.test(d.src)) return !0;
        var f = a.wheelDeltaX || 0, g = a.wheelDeltaY || 0;
        return f || g || (g = a.wheelDelta || 0), !t.touchpadSupport && m(g) ? !0 : (Math.abs(f) > 1.2 && (f *= t.stepSize / 120), Math.abs(g) > 1.2 && (g *= t.stepSize / 120), c(e, -f, -g), void a.preventDefault())
      }

      function e(a) {
        var b = a.target,
          d = a.ctrlKey || a.altKey || a.metaKey || a.shiftKey && a.keyCode !== A.spacebar;
        if (/input|textarea|select|embed/i.test(b.nodeName) || b.isContentEditable || a.defaultPrevented || d) return !0;
        if (k(b, "button") && a.keyCode === A.spacebar) return !0;
        var e, f = 0, g = 0, i = h(q), j = i.clientHeight;
        switch (i == document.body && (j = window.innerHeight), a.keyCode) {
          case A.up:
            g = -t.arrowScroll;
            break;
          case A.down:
            g = t.arrowScroll;
            break;
          case A.spacebar:
            e = a.shiftKey ? 1 : -1, g = -e * j * .9;
            break;
          case A.pageup:
            g = .9 * -j;
            break;
          case A.pagedown:
            g = .9 * j;
            break;
          case A.home:
            g = -i.scrollTop;
            break;
          case A.end:
            var l = i.scrollHeight - i.scrollTop - j;
            g = l > 0 ? l + 10 : 0;
            break;
          case A.left:
            f = -t.arrowScroll;
            break;
          case A.right:
            f = t.arrowScroll;
            break;
          default:
            return !0
        }
        c(i, f, g), a.preventDefault()
      }

      function f(a) {
        q = a.target
      }

      function g(a, b) {
        for (var c = a.length; c--;) E[G(a[c])] = b;
        return b
      }

      function h(a) {
        var b = [], c = y.scrollHeight;
        do {
          var d = E[G(a)];
          if (d) return g(b, d);
          if (b.push(a), c === a.scrollHeight) {
            if (!v || y.clientHeight + 10 < c) return g(b, document.body)
          } else if (a.clientHeight + 10 < a.scrollHeight && (overflow = getComputedStyle(a, "").getPropertyValue("overflow-y"), "scroll" === overflow || "auto" === overflow)) return g(b, a)
        } while (a = a.parentNode)
      }

      function i(a, b, c) {
        window.addEventListener(a, b, c || !1)
      }

      function j(a, b, c) {
        window.removeEventListener(a, b, c || !1)
      }

      function k(a, b) {
        return (a.nodeName || "").toLowerCase() === b.toLowerCase()
      }

      function l(a, b) {
        a = a > 0 ? 1 : -1, b = b > 0 ? 1 : -1, (w.x !== a || w.y !== b) && (w.x = a, w.y = b, B = [], D = 0)
      }

      function m(a) {
        if (a) {
          a = Math.abs(a), z.push(a), z.shift(), clearTimeout(F);
          var b = z[0] == z[1] && z[1] == z[2], c = n(z[0], 120) && n(z[1], 120) && n(z[2], 120);
          return !(b || c)
        }
      }

      function n(a, b) {
        return Math.floor(a / b) == a / b
      }

      function o(a) {
        var b, c, d;
        return a *= t.pulseScale, 1 > a ? b = a - (1 - Math.exp(-a)) : (c = Math.exp(-1), a -= 1, d = 1 - Math.exp(-a), b = c + d * (1 - c)), b * t.pulseNormalize
      }

      function p(a) {
        return a >= 1 ? 1 : 0 >= a ? 0 : (1 == t.pulseNormalize && (t.pulseNormalize /= o(1)), o(a))
      }

      var q, r, s = {
          frameRate: 60,
          animationTime: 700,
          stepSize: 120,
          pulseAlgorithm: !0,
          pulseScale: 10,
          pulseNormalize: 1,
          accelerationDelta: 20,
          accelerationMax: 1,
          keyboardSupport: !0,
          arrowScroll: 50,
          touchpadSupport: !0,
          fixedBackground: !0,
          excluded: ""
        }, t = s, u = !1, v = !1, w = {x: 0, y: 0}, x = !1, y = document.documentElement,
        z = [120, 120, 120], A = {
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          spacebar: 32,
          pageup: 33,
          pagedown: 34,
          end: 35,
          home: 36
        }, B = [], C = !1, D = +new Date, E = {};
      setInterval(function () {
        E = {}
      }, 1e4);
      var F, G = function () {
        var a = 0;
        return function (b) {
          return b.uniqueID || (b.uniqueID = a++)
        }
      }(), H = function () {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || function (a, b, c) {
          window.setTimeout(a, c || 1e3 / 60)
        }
      }(), I = window.MutationObserver || window.WebKitMutationObserver;
      i("mousedown", f), i("mousewheel", d), i("load", b)
    }
  })
}(jQuery);


/* ==========================================================================
   6. jquery.stellar.js
   ========================================================================== */
/*!
 * Stellar.js v0.6.2
 * http://markdalgleish.com/projects/stellar.js
 *
 * Copyright 2013, Mark Dalgleish
 * This content is released under the MIT license
 * http://markdalgleish.mit-license.org
 */


;(function($, window, document, undefined) {

  var pluginName = 'stellar',
    defaults = {
      scrollProperty: 'scroll',
      positionProperty: 'position',
      horizontalScrolling: true,
      verticalScrolling: true,
      horizontalOffset: 0,
      verticalOffset: 0,
      responsive: false,
      parallaxBackgrounds: true,
      parallaxElements: true,
      hideDistantElements: true,
      hideElement: function($elem) { $elem.hide(); },
      showElement: function($elem) { $elem.show(); }
    },

    scrollProperty = {
      scroll: {
        getLeft: function($elem) { return $elem.scrollLeft(); },
        setLeft: function($elem, val) { $elem.scrollLeft(val); },

        getTop: function($elem) { return $elem.scrollTop();	},
        setTop: function($elem, val) { $elem.scrollTop(val); }
      },
      position: {
        getLeft: function($elem) { return parseInt($elem.css('left'), 10) * -1; },
        getTop: function($elem) { return parseInt($elem.css('top'), 10) * -1; }
      },
      margin: {
        getLeft: function($elem) { return parseInt($elem.css('margin-left'), 10) * -1; },
        getTop: function($elem) { return parseInt($elem.css('margin-top'), 10) * -1; }
      },
      transform: {
        getLeft: function($elem) {
          var computedTransform = getComputedStyle($elem[0])[prefixedTransform];
          return (computedTransform !== 'none' ? parseInt(computedTransform.match(/(-?[0-9]+)/g)[4], 10) * -1 : 0);
        },
        getTop: function($elem) {
          var computedTransform = getComputedStyle($elem[0])[prefixedTransform];
          return (computedTransform !== 'none' ? parseInt(computedTransform.match(/(-?[0-9]+)/g)[5], 10) * -1 : 0);
        }
      }
    },

    positionProperty = {
      position: {
        setLeft: function($elem, left) { $elem.css('left', left); },
        setTop: function($elem, top) { $elem.css('top', top); }
      },
      transform: {
        setPosition: function($elem, left, startingLeft, top, startingTop) {
          $elem[0].style[prefixedTransform] = 'translate3d(' + (left - startingLeft) + 'px, ' + (top - startingTop) + 'px, 0)';
        }
      }
    },

    // Returns a function which adds a vendor prefix to any CSS property name
    vendorPrefix = (function() {
      var prefixes = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/,
        style = $('script')[0].style,
        prefix = '',
        prop;

      for (prop in style) {
        if (prefixes.test(prop)) {
          prefix = prop.match(prefixes)[0];
          break;
        }
      }

      if ('WebkitOpacity' in style) { prefix = 'Webkit'; }
      if ('KhtmlOpacity' in style) { prefix = 'Khtml'; }

      return function(property) {
        return prefix + (prefix.length > 0 ? property.charAt(0).toUpperCase() + property.slice(1) : property);
      };
    }()),

    prefixedTransform = vendorPrefix('transform'),

    supportsBackgroundPositionXY = $('<div />', { style: 'background:#fff' }).css('background-position-x') !== undefined,

    setBackgroundPosition = (supportsBackgroundPositionXY ?
        function($elem, x, y) {
          $elem.css({
            'background-position-x': x,
            'background-position-y': y
          });
        } :
        function($elem, x, y) {
          $elem.css('background-position', x + ' ' + y);
        }
    ),

    getBackgroundPosition = (supportsBackgroundPositionXY ?
        function($elem) {
          return [
            $elem.css('background-position-x'),
            $elem.css('background-position-y')
          ];
        } :
        function($elem) {
          return $elem.css('background-position').split(' ');
        }
    ),

    requestAnimFrame = (
      window.requestAnimationFrame	   ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame	||
      window.oRequestAnimationFrame	  ||
      window.msRequestAnimationFrame	 ||
      function(callback) {
        setTimeout(callback, 1000 / 60);
      }
    );

  function Plugin(element, options) {
    this.element = element;
    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype = {
    init: function() {
      this.options.name = pluginName + '_' + Math.floor(Math.random() * 1e9);

      this._defineElements();
      this._defineGetters();
      this._defineSetters();
      this._handleWindowLoadAndResize();
      this._detectViewport();

      this.refresh({ firstLoad: true });

      if (this.options.scrollProperty === 'scroll') {
        this._handleScrollEvent();
      } else {
        this._startAnimationLoop();
      }
    },
    _defineElements: function() {
      if (this.element === document.body) this.element = window;
      this.$scrollElement = $(this.element);
      this.$element = (this.element === window ? $('body') : this.$scrollElement);
      this.$viewportElement = (this.options.viewportElement !== undefined ? $(this.options.viewportElement) : (this.$scrollElement[0] === window || this.options.scrollProperty === 'scroll' ? this.$scrollElement : this.$scrollElement.parent()) );
    },
    _defineGetters: function() {
      var self = this,
        scrollPropertyAdapter = scrollProperty[self.options.scrollProperty];

      this._getScrollLeft = function() {
        return scrollPropertyAdapter.getLeft(self.$scrollElement);
      };

      this._getScrollTop = function() {
        return scrollPropertyAdapter.getTop(self.$scrollElement);
      };
    },
    _defineSetters: function() {
      var self = this,
        scrollPropertyAdapter = scrollProperty[self.options.scrollProperty],
        positionPropertyAdapter = positionProperty[self.options.positionProperty],
        setScrollLeft = scrollPropertyAdapter.setLeft,
        setScrollTop = scrollPropertyAdapter.setTop;

      this._setScrollLeft = (typeof setScrollLeft === 'function' ? function(val) {
        setScrollLeft(self.$scrollElement, val);
      } : $.noop);

      this._setScrollTop = (typeof setScrollTop === 'function' ? function(val) {
        setScrollTop(self.$scrollElement, val);
      } : $.noop);

      this._setPosition = positionPropertyAdapter.setPosition ||
        function($elem, left, startingLeft, top, startingTop) {
          if (self.options.horizontalScrolling) {
            positionPropertyAdapter.setLeft($elem, left, startingLeft);
          }

          if (self.options.verticalScrolling) {
            positionPropertyAdapter.setTop($elem, top, startingTop);
          }
        };
    },
    _handleWindowLoadAndResize: function() {
      var self = this,
        $window = $(window);

      if (self.options.responsive) {
        $window.bind('load.' + this.name, function() {
          self.refresh();
        });
      }

      $window.bind('resize.' + this.name, function() {
        self._detectViewport();

        if (self.options.responsive) {
          self.refresh();
        }
      });
    },
    refresh: function(options) {
      var self = this,
        oldLeft = self._getScrollLeft(),
        oldTop = self._getScrollTop();

      if (!options || !options.firstLoad) {
        this._reset();
      }

      this._setScrollLeft(0);
      this._setScrollTop(0);

      this._setOffsets();
      this._findParticles();
      this._findBackgrounds();

      // Fix for WebKit background rendering bug
      if (options && options.firstLoad && /WebKit/.test(navigator.userAgent)) {
        $(window).load(function() {
          var oldLeft = self._getScrollLeft(),
            oldTop = self._getScrollTop();

          self._setScrollLeft(oldLeft + 1);
          self._setScrollTop(oldTop + 1);

          self._setScrollLeft(oldLeft);
          self._setScrollTop(oldTop);
        });
      }

      this._setScrollLeft(oldLeft);
      this._setScrollTop(oldTop);
    },
    _detectViewport: function() {
      var viewportOffsets = this.$viewportElement.offset(),
        hasOffsets = viewportOffsets !== null && viewportOffsets !== undefined;

      this.viewportWidth = this.$viewportElement.width();
      this.viewportHeight = this.$viewportElement.height();

      this.viewportOffsetTop = (hasOffsets ? viewportOffsets.top : 0);
      this.viewportOffsetLeft = (hasOffsets ? viewportOffsets.left : 0);
    },
    _findParticles: function() {
      var self = this,
        scrollLeft = this._getScrollLeft(),
        scrollTop = this._getScrollTop();

      if (this.particles !== undefined) {
        for (var i = this.particles.length - 1; i >= 0; i--) {
          this.particles[i].$element.data('stellar-elementIsActive', undefined);
        }
      }

      this.particles = [];

      if (!this.options.parallaxElements) return;

      this.$element.find('[data-stellar-ratio]').each(function(i) {
        var $this = $(this),
          horizontalOffset,
          verticalOffset,
          positionLeft,
          positionTop,
          marginLeft,
          marginTop,
          $offsetParent,
          offsetLeft,
          offsetTop,
          parentOffsetLeft = 0,
          parentOffsetTop = 0,
          tempParentOffsetLeft = 0,
          tempParentOffsetTop = 0;

        // Ensure this element isn't already part of another scrolling element
        if (!$this.data('stellar-elementIsActive')) {
          $this.data('stellar-elementIsActive', this);
        } else if ($this.data('stellar-elementIsActive') !== this) {
          return;
        }

        self.options.showElement($this);

        // Save/restore the original top and left CSS values in case we refresh the particles or destroy the instance
        if (!$this.data('stellar-startingLeft')) {
          $this.data('stellar-startingLeft', $this.css('left'));
          $this.data('stellar-startingTop', $this.css('top'));
        } else {
          $this.css('left', $this.data('stellar-startingLeft'));
          $this.css('top', $this.data('stellar-startingTop'));
        }

        positionLeft = $this.position().left;
        positionTop = $this.position().top;

        // Catch-all for margin top/left properties (these evaluate to 'auto' in IE7 and IE8)
        marginLeft = ($this.css('margin-left') === 'auto') ? 0 : parseInt($this.css('margin-left'), 10);
        marginTop = ($this.css('margin-top') === 'auto') ? 0 : parseInt($this.css('margin-top'), 10);

        offsetLeft = $this.offset().left - marginLeft;
        offsetTop = $this.offset().top - marginTop;

        // Calculate the offset parent
        $this.parents().each(function() {
          var $this = $(this);

          if ($this.data('stellar-offset-parent') === true) {
            parentOffsetLeft = tempParentOffsetLeft;
            parentOffsetTop = tempParentOffsetTop;
            $offsetParent = $this;

            return false;
          } else {
            tempParentOffsetLeft += $this.position().left;
            tempParentOffsetTop += $this.position().top;
          }
        });

        // Detect the offsets
        horizontalOffset = ($this.data('stellar-horizontal-offset') !== undefined ? $this.data('stellar-horizontal-offset') : ($offsetParent !== undefined && $offsetParent.data('stellar-horizontal-offset') !== undefined ? $offsetParent.data('stellar-horizontal-offset') : self.horizontalOffset));
        verticalOffset = ($this.data('stellar-vertical-offset') !== undefined ? $this.data('stellar-vertical-offset') : ($offsetParent !== undefined && $offsetParent.data('stellar-vertical-offset') !== undefined ? $offsetParent.data('stellar-vertical-offset') : self.verticalOffset));

        // Add our object to the particles collection
        self.particles.push({
          $element: $this,
          $offsetParent: $offsetParent,
          isFixed: $this.css('position') === 'fixed',
          horizontalOffset: horizontalOffset,
          verticalOffset: verticalOffset,
          startingPositionLeft: positionLeft,
          startingPositionTop: positionTop,
          startingOffsetLeft: offsetLeft,
          startingOffsetTop: offsetTop,
          parentOffsetLeft: parentOffsetLeft,
          parentOffsetTop: parentOffsetTop,
          stellarRatio: ($this.data('stellar-ratio') !== undefined ? $this.data('stellar-ratio') : 1),
          width: $this.outerWidth(true),
          height: $this.outerHeight(true),
          isHidden: false
        });
      });
    },
    _findBackgrounds: function() {
      var self = this,
        scrollLeft = this._getScrollLeft(),
        scrollTop = this._getScrollTop(),
        $backgroundElements;

      this.backgrounds = [];

      if (!this.options.parallaxBackgrounds) return;

      $backgroundElements = this.$element.find('[data-stellar-background-ratio]');

      if (this.$element.data('stellar-background-ratio')) {
        $backgroundElements = $backgroundElements.add(this.$element);
      }

      $backgroundElements.each(function() {
        var $this = $(this),
          backgroundPosition = getBackgroundPosition($this),
          horizontalOffset,
          verticalOffset,
          positionLeft,
          positionTop,
          marginLeft,
          marginTop,
          offsetLeft,
          offsetTop,
          $offsetParent,
          parentOffsetLeft = 0,
          parentOffsetTop = 0,
          tempParentOffsetLeft = 0,
          tempParentOffsetTop = 0;

        // Ensure this element isn't already part of another scrolling element
        if (!$this.data('stellar-backgroundIsActive')) {
          $this.data('stellar-backgroundIsActive', this);
        } else if ($this.data('stellar-backgroundIsActive') !== this) {
          return;
        }

        // Save/restore the original top and left CSS values in case we destroy the instance
        if (!$this.data('stellar-backgroundStartingLeft')) {
          $this.data('stellar-backgroundStartingLeft', backgroundPosition[0]);
          $this.data('stellar-backgroundStartingTop', backgroundPosition[1]);
        } else {
          setBackgroundPosition($this, $this.data('stellar-backgroundStartingLeft'), $this.data('stellar-backgroundStartingTop'));
        }

        // Catch-all for margin top/left properties (these evaluate to 'auto' in IE7 and IE8)
        marginLeft = ($this.css('margin-left') === 'auto') ? 0 : parseInt($this.css('margin-left'), 10);
        marginTop = ($this.css('margin-top') === 'auto') ? 0 : parseInt($this.css('margin-top'), 10);

        offsetLeft = $this.offset().left - marginLeft - scrollLeft;
        offsetTop = $this.offset().top - marginTop - scrollTop;

        // Calculate the offset parent
        $this.parents().each(function() {
          var $this = $(this);

          if ($this.data('stellar-offset-parent') === true) {
            parentOffsetLeft = tempParentOffsetLeft;
            parentOffsetTop = tempParentOffsetTop;
            $offsetParent = $this;

            return false;
          } else {
            tempParentOffsetLeft += $this.position().left;
            tempParentOffsetTop += $this.position().top;
          }
        });

        // Detect the offsets
        horizontalOffset = ($this.data('stellar-horizontal-offset') !== undefined ? $this.data('stellar-horizontal-offset') : ($offsetParent !== undefined && $offsetParent.data('stellar-horizontal-offset') !== undefined ? $offsetParent.data('stellar-horizontal-offset') : self.horizontalOffset));
        verticalOffset = ($this.data('stellar-vertical-offset') !== undefined ? $this.data('stellar-vertical-offset') : ($offsetParent !== undefined && $offsetParent.data('stellar-vertical-offset') !== undefined ? $offsetParent.data('stellar-vertical-offset') : self.verticalOffset));

        self.backgrounds.push({
          $element: $this,
          $offsetParent: $offsetParent,
          isFixed: $this.css('background-attachment') === 'fixed',
          horizontalOffset: horizontalOffset,
          verticalOffset: verticalOffset,
          startingValueLeft: backgroundPosition[0],
          startingValueTop: backgroundPosition[1],
          startingBackgroundPositionLeft: (isNaN(parseInt(backgroundPosition[0], 10)) ? 0 : parseInt(backgroundPosition[0], 10)),
          startingBackgroundPositionTop: (isNaN(parseInt(backgroundPosition[1], 10)) ? 0 : parseInt(backgroundPosition[1], 10)),
          startingPositionLeft: $this.position().left,
          startingPositionTop: $this.position().top,
          startingOffsetLeft: offsetLeft,
          startingOffsetTop: offsetTop,
          parentOffsetLeft: parentOffsetLeft,
          parentOffsetTop: parentOffsetTop,
          stellarRatio: ($this.data('stellar-background-ratio') === undefined ? 1 : $this.data('stellar-background-ratio'))
        });
      });
    },
    _reset: function() {
      var particle,
        startingPositionLeft,
        startingPositionTop,
        background,
        i;

      for (i = this.particles.length - 1; i >= 0; i--) {
        particle = this.particles[i];
        startingPositionLeft = particle.$element.data('stellar-startingLeft');
        startingPositionTop = particle.$element.data('stellar-startingTop');

        this._setPosition(particle.$element, startingPositionLeft, startingPositionLeft, startingPositionTop, startingPositionTop);

        this.options.showElement(particle.$element);

        particle.$element.data('stellar-startingLeft', null).data('stellar-elementIsActive', null).data('stellar-backgroundIsActive', null);
      }

      for (i = this.backgrounds.length - 1; i >= 0; i--) {
        background = this.backgrounds[i];

        background.$element.data('stellar-backgroundStartingLeft', null).data('stellar-backgroundStartingTop', null);

        setBackgroundPosition(background.$element, background.startingValueLeft, background.startingValueTop);
      }
    },
    destroy: function() {
      this._reset();

      this.$scrollElement.unbind('resize.' + this.name).unbind('scroll.' + this.name);
      this._animationLoop = $.noop;

      $(window).unbind('load.' + this.name).unbind('resize.' + this.name);
    },
    _setOffsets: function() {
      var self = this,
        $window = $(window);

      $window.unbind('resize.horizontal-' + this.name).unbind('resize.vertical-' + this.name);

      if (typeof this.options.horizontalOffset === 'function') {
        this.horizontalOffset = this.options.horizontalOffset();
        $window.bind('resize.horizontal-' + this.name, function() {
          self.horizontalOffset = self.options.horizontalOffset();
        });
      } else {
        this.horizontalOffset = this.options.horizontalOffset;
      }

      if (typeof this.options.verticalOffset === 'function') {
        this.verticalOffset = this.options.verticalOffset();
        $window.bind('resize.vertical-' + this.name, function() {
          self.verticalOffset = self.options.verticalOffset();
        });
      } else {
        this.verticalOffset = this.options.verticalOffset;
      }
    },
    _repositionElements: function() {
      var scrollLeft = this._getScrollLeft(),
        scrollTop = this._getScrollTop(),
        horizontalOffset,
        verticalOffset,
        particle,
        fixedRatioOffset,
        background,
        bgLeft,
        bgTop,
        isVisibleVertical = true,
        isVisibleHorizontal = true,
        newPositionLeft,
        newPositionTop,
        newOffsetLeft,
        newOffsetTop,
        i;

      // First check that the scroll position or container size has changed
      if (this.currentScrollLeft === scrollLeft && this.currentScrollTop === scrollTop && this.currentWidth === this.viewportWidth && this.currentHeight === this.viewportHeight) {
        return;
      } else {
        this.currentScrollLeft = scrollLeft;
        this.currentScrollTop = scrollTop;
        this.currentWidth = this.viewportWidth;
        this.currentHeight = this.viewportHeight;
      }

      // Reposition elements
      for (i = this.particles.length - 1; i >= 0; i--) {
        particle = this.particles[i];

        fixedRatioOffset = (particle.isFixed ? 1 : 0);

        // Calculate position, then calculate what the particle's new offset will be (for visibility check)
        if (this.options.horizontalScrolling) {
          newPositionLeft = (scrollLeft + particle.horizontalOffset + this.viewportOffsetLeft + particle.startingPositionLeft - particle.startingOffsetLeft + particle.parentOffsetLeft) * -(particle.stellarRatio + fixedRatioOffset - 1) + particle.startingPositionLeft;
          newOffsetLeft = newPositionLeft - particle.startingPositionLeft + particle.startingOffsetLeft;
        } else {
          newPositionLeft = particle.startingPositionLeft;
          newOffsetLeft = particle.startingOffsetLeft;
        }

        if (this.options.verticalScrolling) {
          newPositionTop = (scrollTop + particle.verticalOffset + this.viewportOffsetTop + particle.startingPositionTop - particle.startingOffsetTop + particle.parentOffsetTop) * -(particle.stellarRatio + fixedRatioOffset - 1) + particle.startingPositionTop;
          newOffsetTop = newPositionTop - particle.startingPositionTop + particle.startingOffsetTop;
        } else {
          newPositionTop = particle.startingPositionTop;
          newOffsetTop = particle.startingOffsetTop;
        }

        // Check visibility
        if (this.options.hideDistantElements) {
          isVisibleHorizontal = !this.options.horizontalScrolling || newOffsetLeft + particle.width > (particle.isFixed ? 0 : scrollLeft) && newOffsetLeft < (particle.isFixed ? 0 : scrollLeft) + this.viewportWidth + this.viewportOffsetLeft;
          isVisibleVertical = !this.options.verticalScrolling || newOffsetTop + particle.height > (particle.isFixed ? 0 : scrollTop) && newOffsetTop < (particle.isFixed ? 0 : scrollTop) + this.viewportHeight + this.viewportOffsetTop;
        }

        if (isVisibleHorizontal && isVisibleVertical) {
          if (particle.isHidden) {
            this.options.showElement(particle.$element);
            particle.isHidden = false;
          }

          this._setPosition(particle.$element, newPositionLeft, particle.startingPositionLeft, newPositionTop, particle.startingPositionTop);
        } else {
          if (!particle.isHidden) {
            this.options.hideElement(particle.$element);
            particle.isHidden = true;
          }
        }
      }

      // Reposition backgrounds
      for (i = this.backgrounds.length - 1; i >= 0; i--) {
        background = this.backgrounds[i];

        fixedRatioOffset = (background.isFixed ? 0 : 1);
        bgLeft = (this.options.horizontalScrolling ? (scrollLeft + background.horizontalOffset - this.viewportOffsetLeft - background.startingOffsetLeft + background.parentOffsetLeft - background.startingBackgroundPositionLeft) * (fixedRatioOffset - background.stellarRatio) + 'px' : background.startingValueLeft);
        bgTop = (this.options.verticalScrolling ? (scrollTop + background.verticalOffset - this.viewportOffsetTop - background.startingOffsetTop + background.parentOffsetTop - background.startingBackgroundPositionTop) * (fixedRatioOffset - background.stellarRatio) + 'px' : background.startingValueTop);

        setBackgroundPosition(background.$element, bgLeft, bgTop);
      }
    },
    _handleScrollEvent: function() {
      var self = this,
        ticking = false;

      var update = function() {
        self._repositionElements();
        ticking = false;
      };

      var requestTick = function() {
        if (!ticking) {
          requestAnimFrame(update);
          ticking = true;
        }
      };

      this.$scrollElement.bind('scroll.' + this.name, requestTick);
      requestTick();
    },
    _startAnimationLoop: function() {
      var self = this;

      this._animationLoop = function() {
        requestAnimFrame(self._animationLoop);
        self._repositionElements();
      };
      this._animationLoop();
    }
  };

  $.fn[pluginName] = function (options) {
    var args = arguments;
    if (options === undefined || typeof options === 'object') {
      return this.each(function () {
        if (!$.data(this, 'plugin_' + pluginName)) {
          $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
      });
    } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
      return this.each(function () {
        var instance = $.data(this, 'plugin_' + pluginName);
        if (instance instanceof Plugin && typeof instance[options] === 'function') {
          instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }
        if (options === 'destroy') {
          $.data(this, 'plugin_' + pluginName, null);
        }
      });
    }
  };

  $[pluginName] = function(options) {
    var $window = $(window);
    return $window.stellar.apply($window, Array.prototype.slice.call(arguments, 0));
  };

  // Expose the scroll and position property function hashes so they can be extended
  $[pluginName].scrollProperty = scrollProperty;
  $[pluginName].positionProperty = positionProperty;

  // Expose the plugin class so it can be modified
  window.Stellar = Plugin;
}(jQuery, this, document));


/* ==========================================================================
   7. jquery.easy-pie-chart.js
   ========================================================================== */
/**!
 * easyPieChart
 * Lightweight plugin to render simple, animated and retina optimized pie charts
 *
 * @license
 * @author Robert Fleischmann <rendro87@gmail.com> (http://robert-fleischmann.de)
 * @version 2.1.6
 **/


(function(root, factory) {
  if(typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  }
  else if(typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  }
  else {
    factory(root.jQuery);
  }
}(this, function($) {

  /**
   * Renderer to render the chart on a canvas object
   * @param {DOMElement} el	  DOM element to host the canvas (root of the plugin)
   * @param {object}	 options options object of the plugin
   */
  var CanvasRenderer = function(el, options) {
    var cachedBackground;
    var canvas = document.createElement('canvas');

    el.appendChild(canvas);

    if (typeof(G_vmlCanvasManager) !== 'undefined') {
      G_vmlCanvasManager.initElement(canvas);
    }

    var ctx = canvas.getContext('2d');

    canvas.width = canvas.height = options.size;

    // canvas on retina devices
    var scaleBy = 1;
    if (window.devicePixelRatio > 1) {
      scaleBy = window.devicePixelRatio;
      canvas.style.width = canvas.style.height = [options.size, 'px'].join('');
      canvas.width = canvas.height = options.size * scaleBy;
      ctx.scale(scaleBy, scaleBy);
    }

    // move 0,0 coordinates to the center
    ctx.translate(options.size / 2, options.size / 2);

    // rotate canvas -90deg
    ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI);

    var radius = (options.size - options.lineWidth) / 2;
    if (options.scaleColor && options.scaleLength) {
      radius -= options.scaleLength + 2; // 2 is the distance between scale and bar
    }

    // IE polyfill for Date
    Date.now = Date.now || function() {
      return +(new Date());
    };

    /**
     * Draw a circle around the center of the canvas
     * @param {strong} color	 Valid CSS color string
     * @param {number} lineWidth Width of the line in px
     * @param {number} percent   Percentage to draw (float between -1 and 1)
     */
    var drawCircle = function(color, lineWidth, percent) {
      percent = Math.min(Math.max(-1, percent || 0), 1);
      var isNegative = percent <= 0 ? true : false;

      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, isNegative);

      ctx.strokeStyle = color;
      ctx.lineWidth = lineWidth;

      ctx.stroke();
    };

    /**
     * Draw the scale of the chart
     */
    var drawScale = function() {
      var offset;
      var length;

      ctx.lineWidth = 1;
      ctx.fillStyle = options.scaleColor;

      ctx.save();
      for (var i = 24; i > 0; --i) {
        if (i % 6 === 0) {
          length = options.scaleLength;
          offset = 0;
        } else {
          length = options.scaleLength * 0.6;
          offset = options.scaleLength - length;
        }
        ctx.fillRect(-options.size/2 + offset, 0, length, 1);
        ctx.rotate(Math.PI / 12);
      }
      ctx.restore();
    };

    /**
     * Request animation frame wrapper with polyfill
     * @return {function} Request animation frame method or timeout fallback
     */
    var reqAnimationFrame = (function() {
      return  window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        };
    }());

    /**
     * Draw the background of the plugin including the scale and the track
     */
    var drawBackground = function() {
      if(options.scaleColor) drawScale();
      if(options.trackColor) drawCircle(options.trackColor, options.trackWidth || options.lineWidth, 1);
    };

    /**
     * Canvas accessor
     */
    this.getCanvas = function() {
      return canvas;
    };

    /**
     * Canvas 2D context 'ctx' accessor
     */
    this.getCtx = function() {
      return ctx;
    };

    /**
     * Clear the complete canvas
     */
    this.clear = function() {
      ctx.clearRect(options.size / -2, options.size / -2, options.size, options.size);
    };

    /**
     * Draw the complete chart
     * @param {number} percent Percent shown by the chart between -100 and 100
     */
    this.draw = function(percent) {
      // do we need to render a background
      if (!!options.scaleColor || !!options.trackColor) {
        // getImageData and putImageData are supported
        if (ctx.getImageData && ctx.putImageData) {
          if (!cachedBackground) {
            drawBackground();
            cachedBackground = ctx.getImageData(0, 0, options.size * scaleBy, options.size * scaleBy);
          } else {
            ctx.putImageData(cachedBackground, 0, 0);
          }
        } else {
          this.clear();
          drawBackground();
        }
      } else {
        this.clear();
      }

      ctx.lineCap = options.lineCap;

      // if barcolor is a function execute it and pass the percent as a value
      var color;
      if (typeof(options.barColor) === 'function') {
        color = options.barColor(percent);
      } else {
        color = options.barColor;
      }

      // draw bar
      drawCircle(color, options.lineWidth, percent / 100);
    }.bind(this);

    /**
     * Animate from some percent to some other percentage
     * @param {number} from Starting percentage
     * @param {number} to   Final percentage
     */
    this.animate = function(from, to) {
      var startTime = Date.now();
      options.onStart(from, to);
      var animation = function() {
        var process = Math.min(Date.now() - startTime, options.animate.duration);
        var currentValue = options.easing(this, process, from, to - from, options.animate.duration);
        this.draw(currentValue);
        options.onStep(from, to, currentValue);
        if (process >= options.animate.duration) {
          options.onStop(from, to);
        } else {
          reqAnimationFrame(animation);
        }
      }.bind(this);

      reqAnimationFrame(animation);
    }.bind(this);
  };

  var EasyPieChart = function(el, opts) {
    var defaultOptions = {
      barColor: '#ef1e25',
      trackColor: '#f9f9f9',
      scaleColor: '#dfe0e0',
      scaleLength: 5,
      lineCap: 'round',
      lineWidth: 3,
      trackWidth: undefined,
      size: 110,
      rotate: 0,
      animate: {
        duration: 1000,
        enabled: true
      },
      easing: function (x, t, b, c, d) { // more can be found here: http://gsgd.co.uk/sandbox/jquery/easing/
        t = t / (d/2);
        if (t < 1) {
          return c / 2 * t * t + b;
        }
        return -c/2 * ((--t)*(t-2) - 1) + b;
      },
      onStart: function(from, to) {
        return;
      },
      onStep: function(from, to, currentValue) {
        return;
      },
      onStop: function(from, to) {
        return;
      }
    };

    // detect present renderer
    if (typeof(CanvasRenderer) !== 'undefined') {
      defaultOptions.renderer = CanvasRenderer;
    } else if (typeof(SVGRenderer) !== 'undefined') {
      defaultOptions.renderer = SVGRenderer;
    } else {
      throw new Error('Please load either the SVG- or the CanvasRenderer');
    }

    var options = {};
    var currentValue = 0;

    /**
     * Initialize the plugin by creating the options object and initialize rendering
     */
    var init = function() {
      this.el = el;
      this.options = options;

      // merge user options into default options
      for (var i in defaultOptions) {
        if (defaultOptions.hasOwnProperty(i)) {
          options[i] = opts && typeof(opts[i]) !== 'undefined' ? opts[i] : defaultOptions[i];
          if (typeof(options[i]) === 'function') {
            options[i] = options[i].bind(this);
          }
        }
      }

      // check for jQuery easing
      if (typeof(options.easing) === 'string' && typeof(jQuery) !== 'undefined' && jQuery.isFunction(jQuery.easing[options.easing])) {
        options.easing = jQuery.easing[options.easing];
      } else {
        options.easing = defaultOptions.easing;
      }

      // process earlier animate option to avoid bc breaks
      if (typeof(options.animate) === 'number') {
        options.animate = {
          duration: options.animate,
          enabled: true
        };
      }

      if (typeof(options.animate) === 'boolean' && !options.animate) {
        options.animate = {
          duration: 1000,
          enabled: options.animate
        };
      }

      // create renderer
      this.renderer = new options.renderer(el, options);

      // initial draw
      this.renderer.draw(currentValue);

      // initial update
      if (el.dataset && el.dataset.percent) {
        this.update(parseFloat(el.dataset.percent));
      } else if (el.getAttribute && el.getAttribute('data-percent')) {
        this.update(parseFloat(el.getAttribute('data-percent')));
      }
    }.bind(this);

    /**
     * Update the value of the chart
     * @param  {number} newValue Number between 0 and 100
     * @return {object}		  Instance of the plugin for method chaining
     */
    this.update = function(newValue) {
      newValue = parseFloat(newValue);
      if (options.animate.enabled) {
        this.renderer.animate(currentValue, newValue);
      } else {
        this.renderer.draw(newValue);
      }
      currentValue = newValue;
      return this;
    }.bind(this);

    /**
     * Disable animation
     * @return {object} Instance of the plugin for method chaining
     */
    this.disableAnimation = function() {
      options.animate.enabled = false;
      return this;
    };

    /**
     * Enable animation
     * @return {object} Instance of the plugin for method chaining
     */
    this.enableAnimation = function() {
      options.animate.enabled = true;
      return this;
    };

    init();
  };

  $.fn.easyPieChart = function(options) {
    return this.each(function() {
      var instanceOptions;

      if (!$.data(this, 'easyPieChart')) {
        instanceOptions = $.extend({}, options, $(this).data());
        $.data(this, 'easyPieChart', new EasyPieChart(this, instanceOptions));
      }
    });
  };


}));


/* ==========================================================================
   8. jquery.gmap.js
   ========================================================================== */
/**
 * jQuery gMap - Google Maps API V3
 *
 * @license MIT License; http://www.opensource.org/licenses/mit-license.php
 * @url   http://github.com/marioestrada/jQuery-gMap
 * @author  Mario Estrada <me@mario.ec> based on original plugin by Cedric Kastner <cedric@nur-text.de>
 * @version 2.1.5
 */
/* global google */

(function($)
{
  // Main plugin function
  $.fn.gMap = function(options, methods_options)
  {
    // Optional methods
    switch(options)
    {
      case 'addMarker':
        return $(this).trigger(
          'gMap.addMarker',
          [methods_options.latitude, methods_options.longitude, methods_options.content, methods_options.icon, methods_options.popup]
        );
      case 'centerAt':
        return $(this).trigger('gMap.centerAt', [methods_options.latitude, methods_options.longitude, methods_options.zoom]);
      case 'clearMarkers':
        return $(this).trigger('gMap.clearMarkers');
    }

    // Build main options before element iteration
    var opts = $.extend({}, $.fn.gMap.defaults, options);

    // Iterate through each element
    return this.each(function()
    {
      // Create map and set initial options
      var $gmap = new google.maps.Map(this);

      $(this).data('gMap.reference', $gmap);

      // Create new object to geocode addresses
      var $geocoder = new google.maps.Geocoder();

      // Check for address to center on
      if (opts.address)
      {
        // Get coordinates for given address and center the map
        $geocoder.geocode(
          {
            address: opts.address
          }, function(gresult, status)
          {
            if(gresult && gresult.length) {
              $gmap.setCenter(gresult[0].geometry.location);
            }
          }
        );
      }else{
        // Check for coordinates to center on
        if (opts.latitude && opts.longitude)
        {
          // Center map to coordinates given by option
          $gmap.setCenter(new google.maps.LatLng(opts.latitude, opts.longitude));
        }
        else
        {
          // Check for a marker to center on (if no coordinates given)
          if ($.isArray(opts.markers) && opts.markers.length > 0)
          {
            // Check if the marker has an address
            if (opts.markers[0].address)
            {
              // Get the coordinates for given marker address and center
              $geocoder.geocode(
                {
                  address: opts.markers[0].address
                }, function(gresult, status)
                {
                  if(gresult && gresult.length > 0) {
                    $gmap.setCenter(gresult[0].geometry.location);
                  }
                }
              );
            }else{
              // Center the map to coordinates given by marker
              $gmap.setCenter(new google.maps.LatLng(opts.markers[0].latitude, opts.markers[0].longitude));
            }
          }else{
            // Revert back to world view
            $gmap.setCenter(new google.maps.LatLng(34.885931, 9.84375));
          }
        }
      }
      $gmap.setZoom(opts.zoom);

      // Set the preferred map type
      $gmap.setMapTypeId(google.maps.MapTypeId[opts.maptype]);

      // Set scrollwheel option
      var map_options = { scrollwheel: opts.scrollwheel, disableDoubleClickZoom: !opts.doubleclickzoom };
      // Check for map controls
      if(opts.controls === false){
        $.extend(map_options, { disableDefaultUI: true });
      }else if (opts.controls.length !== 0){
        $.extend(map_options, opts.controls, { disableDefaultUI: true });
      }

      $gmap.setOptions(map_options);

      // Create new icon
      var gicon = new google.maps.Marker();
      var marker_icon;
      var marker_shadow;

      // Set icon properties from global options
      marker_icon = new google.maps.MarkerImage(opts.icon.image);
      marker_icon.size = new google.maps.Size(opts.icon.iconsize[0], opts.icon.iconsize[1]);
      marker_icon.anchor = new google.maps.Point(opts.icon.iconanchor[0], opts.icon.iconanchor[1]);
      gicon.setIcon(marker_icon);

      if(opts.icon.shadow)
      {
        marker_shadow = new google.maps.MarkerImage(opts.icon.shadow);
        marker_shadow.size = new google.maps.Size(opts.icon.shadowsize[0], opts.icon.shadowsize[1]);
        marker_shadow.anchor = new google.maps.Point(opts.icon.shadowanchor[0], opts.icon.shadowanchor[1]);
        gicon.setShadow(marker_shadow);
      }

      // Bind actions
      $(this).bind('gMap.centerAt', function(e, latitude, longitude, zoom)
      {
        if(zoom) {
          $gmap.setZoom(zoom);
        }

        $gmap.panTo(new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude)));
      });

      // Clear Markers
      var overlays = [];
      $(this).bind('gMap.clearMarkers', function()
      {
        while(overlays[0]){
          overlays.pop().setMap(null);
        }
      });

      var last_infowindow;
      $(this).bind('gMap.addMarker', function(e, latitude, longitude, content, icon, popup)
      {
        var marker_icon;
        var marker_shadow;
        var glatlng = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));

        var gmarker = new google.maps.Marker({
          position: glatlng
        });

        if(icon)
        {
          marker_icon = new google.maps.MarkerImage(icon.image);
          marker_icon.size = new google.maps.Size(icon.iconsize[0], icon.iconsize[1]);
          marker_icon.anchor = new google.maps.Point(icon.iconanchor[0], icon.iconanchor[1]);
          gmarker.setIcon(marker_icon);

          if(icon.shadow)
          {
            marker_shadow = new google.maps.MarkerImage(icon.shadow);
            marker_shadow.size = new google.maps.Size(icon.shadowsize[0], icon.shadowsize[1]);
            marker_shadow.anchor = new google.maps.Point(icon.shadowanchor[0], icon.shadowanchor[1]);
            gicon.setShadow(marker_shadow);
          }
        }else{
          gmarker.setIcon(gicon.getIcon());
          gmarker.setShadow(gicon.getShadow());
        }

        if(content)
        {
          if(content === '_latlng') {
            content = latitude + ', ' + longitude;
          }

          var infowindow = new google.maps.InfoWindow({
            content: opts.html_prepend + content + opts.html_append
          });

          google.maps.event.addListener(gmarker, 'click', function()
          {
            if (last_infowindow) {
              last_infowindow.close();
            }
            infowindow.open($gmap, gmarker);
            last_infowindow = infowindow;
          });

          if(popup)
          {
            google.maps.event.addListenerOnce($gmap, 'tilesloaded', function()
            {
              infowindow.open($gmap, gmarker);
            });
          }
        }
        gmarker.setMap($gmap);
        overlays.push(gmarker);
      });

      var marker;
      var self = this;
      var geocode_callback = function(marker) {
        return function(gresult, status) {
          // Create marker
          if(gresult && gresult.length > 0)
          {
            $(self).trigger(
              'gMap.addMarker',
              [gresult[0].geometry.location.lat(), gresult[0].geometry.location.lng(), marker.html, marker.icon, marker.popup]
            );
          }
        };
      };

      // Loop through marker array
      for (var j = 0; j < opts.markers.length; j++)
      {
        // Get the options from current marker
        marker = opts.markers[j];

        // Check if address is available
        if (marker.address)
        {
          // Check for reference to the marker's address
          if (marker.html === '_address') {
            marker.html = marker.address;
          }

          // Get the point for given address
          $geocoder.geocode({
            address: marker.address
          }, geocode_callback(marker));
        }else{
          $(this).trigger('gMap.addMarker', [marker.latitude, marker.longitude, marker.html, marker.icon, marker.popup]);
        }
      }
    });

  };

  // Default settings
  $.fn.gMap.defaults = {
    address: '',
    latitude: 0,
    longitude: 0,
    zoom: 1,
    markers: [],
    controls: [],
    scrollwheel: false,
    doubleclickzoom: true,
    maptype: 'ROADMAP',
    html_prepend: '<div class="gmap_marker">',
    html_append: '</div>',
    icon: {
      image: "http://www.google.com/mapfiles/marker.png",
      shadow: "http://www.google.com/mapfiles/shadow50.png",
      iconsize: [20, 34],
      shadowsize: [37, 34],
      iconanchor: [9, 34],
      shadowanchor: [6, 34]
    }
  };

})(jQuery);


/* ==========================================================================
   11. jflickrfeed.js
   ========================================================================== */
/*
* Copyright (C) 2009 Joel Sutherland
* Licenced under the MIT license
* http://www.newmediacampaigns.com/page/jquery-flickr-plugin
*
* Available tags for templates:
* title, link, date_taken, description, published, author, author_id, tags, image*
*/

(function($) {
  $.fn.jflickrfeed = function(settings, callback) {
    settings = $.extend(true, {
      flickrbase: 'http://api.flickr.com/services/feeds/',
      feedapi: 'photos_public.gne',
      limit: 20,
      qstrings: {
        lang: 'en-us',
        format: 'json',
        jsoncallback: '?'
      },
      cleanDescription: true,
      useTemplate: true,
      itemTemplate: '<li><a href="{{image_b}}" title="{{title}}"><span class="thumbnail"><img src="{{image_s}}" /></span></a></li>',
      itemCallback: function(){}
    }, settings);

    var url = settings.flickrbase + settings.feedapi + '?';
    var first = true;

    for(var key in settings.qstrings){
      if(!first)
        url += '&';
      url += key + '=' + settings.qstrings[key];
      first = false;
    }

    return $(this).each(function(){
      var $container = $(this);
      var container = this;

      $.getJSON(url, function(data){

        $.each(data.items, function(i,item){
          if(i < settings.limit){
            // Clean out the Flickr Description
            if(settings.cleanDescription){
              var regex = /<p>(.*?)<\/p>/g;
              var input = item.description;
              if(regex.test(input)) {
                item.description = input.match(regex)[2]
                if(item.description!=undefined)
                  item.description = item.description.replace('<p>','').replace('</p>','');
              }
            }

            // Add Image Sizes
            // http://www.flickr.com/services/api/misc.urls.html
            item['image_s'] = item.media.m.replace('_m', '_s');
            item['image_t'] = item.media.m.replace('_m', '_t');
            item['image_m'] = item.media.m.replace('_m', '_m');
            item['image'] = item.media.m.replace('_m', '');
            item['image_b'] = item.media.m.replace('_m', '_b');
            delete item.media;

            // Use Template
            if(settings.useTemplate){
              var template = settings.itemTemplate;
              for(var key in item){
                template = template.replace('{{' + key + '}}', item[key]);
              }

              $container.append(template)
            }

            //itemCallback
            settings.itemCallback.call(container, item);
          }
        });
        if($.isFunction(callback)){
          callback.call(container, data);
        }
      });
    });
  }
})(jQuery);


/* ==========================================================================
   12. jquery.magnific-popup.js
   ========================================================================== */
/*! Magnific Popup - v1.0.0 - 2014-12-12
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2014 Dmitry Semenov; */

;(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(window.jQuery || window.Zepto);
  }
}(function($) {

  /*>>core*/
  /**
   *
   * Magnific Popup Core JS file
   *
   */


  /**
   * Private static constants
   */
  var CLOSE_EVENT = 'Close',
    BEFORE_CLOSE_EVENT = 'BeforeClose',
    AFTER_CLOSE_EVENT = 'AfterClose',
    BEFORE_APPEND_EVENT = 'BeforeAppend',
    MARKUP_PARSE_EVENT = 'MarkupParse',
    OPEN_EVENT = 'Open',
    CHANGE_EVENT = 'Change',
    NS = 'mfp',
    EVENT_NS = '.' + NS,
    READY_CLASS = 'mfp-ready',
    REMOVING_CLASS = 'mfp-removing',
    PREVENT_CLOSE_CLASS = 'mfp-prevent-close';


  /**
   * Private vars
   */
  var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
    MagnificPopup = function(){},
    _isJQ = !!(window.jQuery),
    _prevStatus,
    _window = $(window),
    _body,
    _document,
    _prevContentType,
    _wrapClasses,
    _currPopupType;


  /**
   * Private functions
   */
  var _mfpOn = function(name, f) {
      mfp.ev.on(NS + name + EVENT_NS, f);
    },
    _getEl = function(className, appendTo, html, raw) {
      var el = document.createElement('div');
      el.className = 'mfp-'+className;
      if(html) {
        el.innerHTML = html;
      }
      if(!raw) {
        el = $(el);
        if(appendTo) {
          el.appendTo(appendTo);
        }
      } else if(appendTo) {
        appendTo.appendChild(el);
      }
      return el;
    },
    _mfpTrigger = function(e, data) {
      mfp.ev.triggerHandler(NS + e, data);

      if(mfp.st.callbacks) {
        // converts "mfpEventName" to "eventName" callback and triggers it if it's present
        e = e.charAt(0).toLowerCase() + e.slice(1);
        if(mfp.st.callbacks[e]) {
          mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]);
        }
      }
    },
    _getCloseBtn = function(type) {
      if(type !== _currPopupType || !mfp.currTemplate.closeBtn) {
        mfp.currTemplate.closeBtn = $( mfp.st.closeMarkup.replace('%title%', mfp.st.tClose ) );
        _currPopupType = type;
      }
      return mfp.currTemplate.closeBtn;
    },
    // Initialize Magnific Popup only when called at least once
    _checkInstance = function() {
      if(!$.magnificPopup.instance) {
        mfp = new MagnificPopup();
        mfp.init();
        $.magnificPopup.instance = mfp;
      }
    },
    // CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
    supportsTransitions = function() {
      var s = document.createElement('p').style, // 's' for style. better to create an element if body yet to exist
        v = ['ms','O','Moz','Webkit']; // 'v' for vendor

      if( s['transition'] !== undefined ) {
        return true;
      }

      while( v.length ) {
        if( v.pop() + 'Transition' in s ) {
          return true;
        }
      }

      return false;
    };



  /**
   * Public functions
   */
  MagnificPopup.prototype = {

    constructor: MagnificPopup,

    /**
     * Initializes Magnific Popup plugin.
     * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
     */
    init: function() {
      var appVersion = navigator.appVersion;
      mfp.isIE7 = appVersion.indexOf("MSIE 7.") !== -1;
      mfp.isIE8 = appVersion.indexOf("MSIE 8.") !== -1;
      mfp.isLowIE = mfp.isIE7 || mfp.isIE8;
      mfp.isAndroid = (/android/gi).test(appVersion);
      mfp.isIOS = (/iphone|ipad|ipod/gi).test(appVersion);
      mfp.supportsTransition = supportsTransitions();

      // We disable fixed positioned lightbox on devices that don't handle it nicely.
      // If you know a better way of detecting this - let me know.
      mfp.probablyMobile = (mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent) );
      _document = $(document);

      mfp.popupsCache = {};
    },

    /**
     * Opens popup
     * @param  data [description]
     */
    open: function(data) {

      if(!_body) {
        _body = $(document.body);
      }

      var i;

      if(data.isObj === false) {
        // convert jQuery collection to array to avoid conflicts later
        mfp.items = data.items.toArray();

        mfp.index = 0;
        var items = data.items,
          item;
        for(i = 0; i < items.length; i++) {
          item = items[i];
          if(item.parsed) {
            item = item.el[0];
          }
          if(item === data.el[0]) {
            mfp.index = i;
            break;
          }
        }
      } else {
        mfp.items = $.isArray(data.items) ? data.items : [data.items];
        mfp.index = data.index || 0;
      }

      // if popup is already opened - we just update the content
      if(mfp.isOpen) {
        mfp.updateItemHTML();
        return;
      }

      mfp.types = [];
      _wrapClasses = '';
      if(data.mainEl && data.mainEl.length) {
        mfp.ev = data.mainEl.eq(0);
      } else {
        mfp.ev = _document;
      }

      if(data.key) {
        if(!mfp.popupsCache[data.key]) {
          mfp.popupsCache[data.key] = {};
        }
        mfp.currTemplate = mfp.popupsCache[data.key];
      } else {
        mfp.currTemplate = {};
      }



      mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data );
      mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;

      if(mfp.st.modal) {
        mfp.st.closeOnContentClick = false;
        mfp.st.closeOnBgClick = false;
        mfp.st.showCloseBtn = false;
        mfp.st.enableEscapeKey = false;
      }


      // Building markup
      // main containers are created only once
      if(!mfp.bgOverlay) {

        // Dark overlay
        mfp.bgOverlay = _getEl('bg').on('click'+EVENT_NS, function() {
          mfp.close();
        });

        mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click'+EVENT_NS, function(e) {
          if(mfp._checkIfClose(e.target)) {
            mfp.close();
          }
        });

        mfp.container = _getEl('container', mfp.wrap);
      }

      mfp.contentContainer = _getEl('content');
      if(mfp.st.preloader) {
        mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
      }


      // Initializing modules
      var modules = $.magnificPopup.modules;
      for(i = 0; i < modules.length; i++) {
        var n = modules[i];
        n = n.charAt(0).toUpperCase() + n.slice(1);
        mfp['init'+n].call(mfp);
      }
      _mfpTrigger('BeforeOpen');


      if(mfp.st.showCloseBtn) {
        // Close button
        if(!mfp.st.closeBtnInside) {
          mfp.wrap.append( _getCloseBtn() );
        } else {
          _mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
            values.close_replaceWith = _getCloseBtn(item.type);
          });
          _wrapClasses += ' mfp-close-btn-in';
        }
      }

      if(mfp.st.alignTop) {
        _wrapClasses += ' mfp-align-top';
      }



      if(mfp.fixedContentPos) {
        mfp.wrap.css({
          overflow: mfp.st.overflowY,
          overflowX: 'hidden',
          overflowY: mfp.st.overflowY
        });
      } else {
        mfp.wrap.css({
          top: _window.scrollTop(),
          position: 'absolute'
        });
      }
      if( mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) ) {
        mfp.bgOverlay.css({
          height: _document.height(),
          position: 'absolute'
        });
      }



      if(mfp.st.enableEscapeKey) {
        // Close on ESC key
        _document.on('keyup' + EVENT_NS, function(e) {
          if(e.keyCode === 27) {
            mfp.close();
          }
        });
      }

      _window.on('resize' + EVENT_NS, function() {
        mfp.updateSize();
      });


      if(!mfp.st.closeOnContentClick) {
        _wrapClasses += ' mfp-auto-cursor';
      }

      if(_wrapClasses)
        mfp.wrap.addClass(_wrapClasses);


      // this triggers recalculation of layout, so we get it once to not to trigger twice
      var windowHeight = mfp.wH = _window.height();


      var windowStyles = {};

      if( mfp.fixedContentPos ) {
        if(mfp._hasScrollBar(windowHeight)){
          var s = mfp._getScrollbarSize();
          if(s) {
            windowStyles.marginRight = s;
          }
        }
      }

      if(mfp.fixedContentPos) {
        if(!mfp.isIE7) {
          windowStyles.overflow = 'hidden';
        } else {
          // ie7 double-scroll bug
          $('body, html').css('overflow', 'hidden');
        }
      }



      var classesToadd = mfp.st.mainClass;
      if(mfp.isIE7) {
        classesToadd += ' mfp-ie7';
      }
      if(classesToadd) {
        mfp._addClassToMFP( classesToadd );
      }

      // add content
      mfp.updateItemHTML();

      _mfpTrigger('BuildControls');

      // remove scrollbar, add margin e.t.c
      $('html').css(windowStyles);

      // add everything to DOM
      mfp.bgOverlay.add(mfp.wrap).prependTo( mfp.st.prependTo || _body );

      // Save last focused element
      mfp._lastFocusedEl = document.activeElement;

      // Wait for next cycle to allow CSS transition
      setTimeout(function() {

        if(mfp.content) {
          mfp._addClassToMFP(READY_CLASS);
          mfp._setFocus();
        } else {
          // if content is not defined (not loaded e.t.c) we add class only for BG
          mfp.bgOverlay.addClass(READY_CLASS);
        }

        // Trap the focus in popup
        _document.on('focusin' + EVENT_NS, mfp._onFocusIn);

      }, 16);

      mfp.isOpen = true;
      mfp.updateSize(windowHeight);
      _mfpTrigger(OPEN_EVENT);

      return data;
    },

    /**
     * Closes the popup
     */
    close: function() {
      if(!mfp.isOpen) return;
      _mfpTrigger(BEFORE_CLOSE_EVENT);

      mfp.isOpen = false;
      // for CSS3 animation
      if(mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition )  {
        mfp._addClassToMFP(REMOVING_CLASS);
        setTimeout(function() {
          mfp._close();
        }, mfp.st.removalDelay);
      } else {
        mfp._close();
      }
    },

    /**
     * Helper for close() function
     */
    _close: function() {
      _mfpTrigger(CLOSE_EVENT);

      var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';

      mfp.bgOverlay.detach();
      mfp.wrap.detach();
      mfp.container.empty();

      if(mfp.st.mainClass) {
        classesToRemove += mfp.st.mainClass + ' ';
      }

      mfp._removeClassFromMFP(classesToRemove);

      if(mfp.fixedContentPos) {
        var windowStyles = {marginRight: ''};
        if(mfp.isIE7) {
          $('body, html').css('overflow', '');
        } else {
          windowStyles.overflow = '';
        }
        $('html').css(windowStyles);
      }

      _document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
      mfp.ev.off(EVENT_NS);

      // clean up DOM elements that aren't removed
      mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
      mfp.bgOverlay.attr('class', 'mfp-bg');
      mfp.container.attr('class', 'mfp-container');

      // remove close button from target element
      if(mfp.st.showCloseBtn &&
        (!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
        if(mfp.currTemplate.closeBtn)
          mfp.currTemplate.closeBtn.detach();
      }


      if(mfp._lastFocusedEl) {
        $(mfp._lastFocusedEl).focus(); // put tab focus back
      }
      mfp.currItem = null;
      mfp.content = null;
      mfp.currTemplate = null;
      mfp.prevHeight = 0;

      _mfpTrigger(AFTER_CLOSE_EVENT);
    },

    updateSize: function(winHeight) {

      if(mfp.isIOS) {
        // fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
        var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
        var height = window.innerHeight * zoomLevel;
        mfp.wrap.css('height', height);
        mfp.wH = height;
      } else {
        mfp.wH = winHeight || _window.height();
      }
      // Fixes #84: popup incorrectly positioned with position:relative on body
      if(!mfp.fixedContentPos) {
        mfp.wrap.css('height', mfp.wH);
      }

      _mfpTrigger('Resize');

    },

    /**
     * Set content of popup based on current index
     */
    updateItemHTML: function() {
      var item = mfp.items[mfp.index];

      // Detach and perform modifications
      mfp.contentContainer.detach();

      if(mfp.content)
        mfp.content.detach();

      if(!item.parsed) {
        item = mfp.parseEl( mfp.index );
      }

      var type = item.type;

      _mfpTrigger('BeforeChange', [mfp.currItem ? mfp.currItem.type : '', type]);
      // BeforeChange event works like so:
      // _mfpOn('BeforeChange', function(e, prevType, newType) { });

      mfp.currItem = item;





      if(!mfp.currTemplate[type]) {
        var markup = mfp.st[type] ? mfp.st[type].markup : false;

        // allows to modify markup
        _mfpTrigger('FirstMarkupParse', markup);

        if(markup) {
          mfp.currTemplate[type] = $(markup);
        } else {
          // if there is no markup found we just define that template is parsed
          mfp.currTemplate[type] = true;
        }
      }

      if(_prevContentType && _prevContentType !== item.type) {
        mfp.container.removeClass('mfp-'+_prevContentType+'-holder');
      }

      var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
      mfp.appendContent(newContent, type);

      item.preloaded = true;

      _mfpTrigger(CHANGE_EVENT, item);
      _prevContentType = item.type;

      // Append container back after its content changed
      mfp.container.prepend(mfp.contentContainer);

      _mfpTrigger('AfterChange');
    },


    /**
     * Set HTML content of popup
     */
    appendContent: function(newContent, type) {
      mfp.content = newContent;

      if(newContent) {
        if(mfp.st.showCloseBtn && mfp.st.closeBtnInside &&
          mfp.currTemplate[type] === true) {
          // if there is no markup, we just append close button element inside
          if(!mfp.content.find('.mfp-close').length) {
            mfp.content.append(_getCloseBtn());
          }
        } else {
          mfp.content = newContent;
        }
      } else {
        mfp.content = '';
      }

      _mfpTrigger(BEFORE_APPEND_EVENT);
      mfp.container.addClass('mfp-'+type+'-holder');

      mfp.contentContainer.append(mfp.content);
    },




    /**
     * Creates Magnific Popup data object based on given data
     * @param  {int} index Index of item to parse
     */
    parseEl: function(index) {
      var item = mfp.items[index],
        type;

      if(item.tagName) {
        item = { el: $(item) };
      } else {
        type = item.type;
        item = { data: item, src: item.src };
      }

      if(item.el) {
        var types = mfp.types;

        // check for 'mfp-TYPE' class
        for(var i = 0; i < types.length; i++) {
          if( item.el.hasClass('mfp-'+types[i]) ) {
            type = types[i];
            break;
          }
        }

        item.src = item.el.attr('data-mfp-src');
        if(!item.src) {
          item.src = item.el.attr('href');
        }
      }

      item.type = type || mfp.st.type || 'inline';
      item.index = index;
      item.parsed = true;
      mfp.items[index] = item;
      _mfpTrigger('ElementParse', item);

      return mfp.items[index];
    },


    /**
     * Initializes single popup or a group of popups
     */
    addGroup: function(el, options) {
      var eHandler = function(e) {
        e.mfpEl = this;
        mfp._openClick(e, el, options);
      };

      if(!options) {
        options = {};
      }

      var eName = 'click.magnificPopup';
      options.mainEl = el;

      if(options.items) {
        options.isObj = true;
        el.off(eName).on(eName, eHandler);
      } else {
        options.isObj = false;
        if(options.delegate) {
          el.off(eName).on(eName, options.delegate , eHandler);
        } else {
          options.items = el;
          el.off(eName).on(eName, eHandler);
        }
      }
    },
    _openClick: function(e, el, options) {
      var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;


      if(!midClick && ( e.which === 2 || e.ctrlKey || e.metaKey ) ) {
        return;
      }

      var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;

      if(disableOn) {
        if($.isFunction(disableOn)) {
          if( !disableOn.call(mfp) ) {
            return true;
          }
        } else { // else it's number
          if( _window.width() < disableOn ) {
            return true;
          }
        }
      }

      if(e.type) {
        e.preventDefault();

        // This will prevent popup from closing if element is inside and popup is already opened
        if(mfp.isOpen) {
          e.stopPropagation();
        }
      }


      options.el = $(e.mfpEl);
      if(options.delegate) {
        options.items = el.find(options.delegate);
      }
      mfp.open(options);
    },


    /**
     * Updates text on preloader
     */
    updateStatus: function(status, text) {

      if(mfp.preloader) {
        if(_prevStatus !== status) {
          mfp.container.removeClass('mfp-s-'+_prevStatus);
        }

        if(!text && status === 'loading') {
          text = mfp.st.tLoading;
        }

        var data = {
          status: status,
          text: text
        };
        // allows to modify status
        _mfpTrigger('UpdateStatus', data);

        status = data.status;
        text = data.text;

        mfp.preloader.html(text);

        mfp.preloader.find('a').on('click', function(e) {
          e.stopImmediatePropagation();
        });

        mfp.container.addClass('mfp-s-'+status);
        _prevStatus = status;
      }
    },


    /*
		"Private" helpers that aren't private at all
	 */
    // Check to close popup or not
    // "target" is an element that was clicked
    _checkIfClose: function(target) {

      if($(target).hasClass(PREVENT_CLOSE_CLASS)) {
        return;
      }

      var closeOnContent = mfp.st.closeOnContentClick;
      var closeOnBg = mfp.st.closeOnBgClick;

      if(closeOnContent && closeOnBg) {
        return true;
      } else {

        // We close the popup if click is on close button or on preloader. Or if there is no content.
        if(!mfp.content || $(target).hasClass('mfp-close') || (mfp.preloader && target === mfp.preloader[0]) ) {
          return true;
        }

        // if click is outside the content
        if(  (target !== mfp.content[0] && !$.contains(mfp.content[0], target))  ) {
          if(closeOnBg) {
            // last check, if the clicked element is in DOM, (in case it's removed onclick)
            if( $.contains(document, target) ) {
              return true;
            }
          }
        } else if(closeOnContent) {
          return true;
        }

      }
      return false;
    },
    _addClassToMFP: function(cName) {
      mfp.bgOverlay.addClass(cName);
      mfp.wrap.addClass(cName);
    },
    _removeClassFromMFP: function(cName) {
      this.bgOverlay.removeClass(cName);
      mfp.wrap.removeClass(cName);
    },
    _hasScrollBar: function(winHeight) {
      return (  (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height()) );
    },
    _setFocus: function() {
      (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
    },
    _onFocusIn: function(e) {
      if( e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target) ) {
        mfp._setFocus();
        return false;
      }
    },
    _parseMarkup: function(template, values, item) {
      var arr;
      if(item.data) {
        values = $.extend(item.data, values);
      }
      _mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item] );

      $.each(values, function(key, value) {
        if(value === undefined || value === false) {
          return true;
        }
        arr = key.split('_');
        if(arr.length > 1) {
          var el = template.find(EVENT_NS + '-'+arr[0]);

          if(el.length > 0) {
            var attr = arr[1];
            if(attr === 'replaceWith') {
              if(el[0] !== value[0]) {
                el.replaceWith(value);
              }
            } else if(attr === 'img') {
              if(el.is('img')) {
                el.attr('src', value);
              } else {
                el.replaceWith( '<img src="'+value+'" class="' + el.attr('class') + '" />' );
              }
            } else {
              el.attr(arr[1], value);
            }
          }

        } else {
          template.find(EVENT_NS + '-'+key).html(value);
        }
      });
    },

    _getScrollbarSize: function() {
      // thx David
      if(mfp.scrollbarSize === undefined) {
        var scrollDiv = document.createElement("div");
        scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
        document.body.appendChild(scrollDiv);
        mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
      }
      return mfp.scrollbarSize;
    }

  }; /* MagnificPopup core prototype end */




  /**
   * Public static functions
   */
  $.magnificPopup = {
    instance: null,
    proto: MagnificPopup.prototype,
    modules: [],

    open: function(options, index) {
      _checkInstance();

      if(!options) {
        options = {};
      } else {
        options = $.extend(true, {}, options);
      }


      options.isObj = true;
      options.index = index || 0;
      return this.instance.open(options);
    },

    close: function() {
      return $.magnificPopup.instance && $.magnificPopup.instance.close();
    },

    registerModule: function(name, module) {
      if(module.options) {
        $.magnificPopup.defaults[name] = module.options;
      }
      $.extend(this.proto, module.proto);
      this.modules.push(name);
    },

    defaults: {

      // Info about options is in docs:
      // http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

      disableOn: 0,

      key: null,

      midClick: false,

      mainClass: '',

      preloader: true,

      focus: '', // CSS selector of input to focus after popup is opened

      closeOnContentClick: false,

      closeOnBgClick: true,

      closeBtnInside: true,

      showCloseBtn: true,

      enableEscapeKey: true,

      modal: false,

      alignTop: false,

      removalDelay: 0,

      prependTo: null,

      fixedContentPos: 'auto',

      fixedBgPos: 'auto',

      overflowY: 'auto',

      closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',

      tClose: 'Close (Esc)',

      tLoading: 'Loading...'

    }
  };



  $.fn.magnificPopup = function(options) {
    _checkInstance();

    var jqEl = $(this);

    // We call some API method of first param is a string
    if (typeof options === "string" ) {

      if(options === 'open') {
        var items,
          itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup,
          index = parseInt(arguments[1], 10) || 0;

        if(itemOpts.items) {
          items = itemOpts.items[index];
        } else {
          items = jqEl;
          if(itemOpts.delegate) {
            items = items.find(itemOpts.delegate);
          }
          items = items.eq( index );
        }
        mfp._openClick({mfpEl:items}, jqEl, itemOpts);
      } else {
        if(mfp.isOpen)
          mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
      }

    } else {
      // clone options obj
      options = $.extend(true, {}, options);

      /*
		 * As Zepto doesn't support .data() method for objects
		 * and it works only in normal browsers
		 * we assign "options" object directly to the DOM element. FTW!
		 */
      if(_isJQ) {
        jqEl.data('magnificPopup', options);
      } else {
        jqEl[0].magnificPopup = options;
      }

      mfp.addGroup(jqEl, options);

    }
    return jqEl;
  };


//Quick benchmark
  /*
var start = performance.now(),
	i,
	rounds = 1000;

for(i = 0; i < rounds; i++) {

}
console.log('Test #1:', performance.now() - start);

start = performance.now();
for(i = 0; i < rounds; i++) {

}
console.log('Test #2:', performance.now() - start);
*/


  /*>>core*/

  /*>>inline*/

  var INLINE_NS = 'inline',
    _hiddenClass,
    _inlinePlaceholder,
    _lastInlineElement,
    _putInlineElementsBack = function() {
      if(_lastInlineElement) {
        _inlinePlaceholder.after( _lastInlineElement.addClass(_hiddenClass) ).detach();
        _lastInlineElement = null;
      }
    };

  $.magnificPopup.registerModule(INLINE_NS, {
    options: {
      hiddenClass: 'hide', // will be appended with `mfp-` prefix
      markup: '',
      tNotFound: 'Content not found'
    },
    proto: {

      initInline: function() {
        mfp.types.push(INLINE_NS);

        _mfpOn(CLOSE_EVENT+'.'+INLINE_NS, function() {
          _putInlineElementsBack();
        });
      },

      getInline: function(item, template) {

        _putInlineElementsBack();

        if(item.src) {
          var inlineSt = mfp.st.inline,
            el = $(item.src);

          if(el.length) {

            // If target element has parent - we replace it with placeholder and put it back after popup is closed
            var parent = el[0].parentNode;
            if(parent && parent.tagName) {
              if(!_inlinePlaceholder) {
                _hiddenClass = inlineSt.hiddenClass;
                _inlinePlaceholder = _getEl(_hiddenClass);
                _hiddenClass = 'mfp-'+_hiddenClass;
              }
              // replace target inline element with placeholder
              _lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
            }

            mfp.updateStatus('ready');
          } else {
            mfp.updateStatus('error', inlineSt.tNotFound);
            el = $('<div>');
          }

          item.inlineElement = el;
          return el;
        }

        mfp.updateStatus('ready');
        mfp._parseMarkup(template, {}, item);
        return template;
      }
    }
  });

  /*>>inline*/

  /*>>ajax*/
  var AJAX_NS = 'ajax',
    _ajaxCur,
    _removeAjaxCursor = function() {
      if(_ajaxCur) {
        _body.removeClass(_ajaxCur);
      }
    },
    _destroyAjaxRequest = function() {
      _removeAjaxCursor();
      if(mfp.req) {
        mfp.req.abort();
      }
    };

  $.magnificPopup.registerModule(AJAX_NS, {

    options: {
      settings: null,
      cursor: 'mfp-ajax-cur',
      tError: '<a href="%url%">The content</a> could not be loaded.'
    },

    proto: {
      initAjax: function() {
        mfp.types.push(AJAX_NS);
        _ajaxCur = mfp.st.ajax.cursor;

        _mfpOn(CLOSE_EVENT+'.'+AJAX_NS, _destroyAjaxRequest);
        _mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
      },
      getAjax: function(item) {

        if(_ajaxCur)
          _body.addClass(_ajaxCur);

        mfp.updateStatus('loading');

        var opts = $.extend({
          url: item.src,
          success: function(data, textStatus, jqXHR) {
            var temp = {
              data:data,
              xhr:jqXHR
            };

            _mfpTrigger('ParseAjax', temp);

            mfp.appendContent( $(temp.data), AJAX_NS );

            item.finished = true;

            _removeAjaxCursor();

            mfp._setFocus();

            setTimeout(function() {
              mfp.wrap.addClass(READY_CLASS);
            }, 16);

            mfp.updateStatus('ready');

            _mfpTrigger('AjaxContentAdded');
          },
          error: function() {
            _removeAjaxCursor();
            item.finished = item.loadError = true;
            mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
          }
        }, mfp.st.ajax.settings);

        mfp.req = $.ajax(opts);

        return '';
      }
    }
  });







  /*>>ajax*/

  /*>>image*/
  var _imgInterval,
    _getTitle = function(item) {
      if(item.data && item.data.title !== undefined)
        return item.data.title;

      var src = mfp.st.image.titleSrc;

      if(src) {
        if($.isFunction(src)) {
          return src.call(mfp, item);
        } else if(item.el) {
          return item.el.attr(src) || '';
        }
      }
      return '';
    };

  $.magnificPopup.registerModule('image', {

    options: {
      markup: '<div class="mfp-figure">'+
      '<div class="mfp-close"></div>'+
      '<figure>'+
      '<div class="mfp-img"></div>'+
      '<figcaption>'+
      '<div class="mfp-bottom-bar">'+
      '<div class="mfp-title"></div>'+
      '<div class="mfp-counter"></div>'+
      '</div>'+
      '</figcaption>'+
      '</figure>'+
      '</div>',
      cursor: 'mfp-zoom-out-cur',
      titleSrc: 'title',
      verticalFit: true,
      tError: '<a href="%url%">The image</a> could not be loaded.'
    },

    proto: {
      initImage: function() {
        var imgSt = mfp.st.image,
          ns = '.image';

        mfp.types.push('image');

        _mfpOn(OPEN_EVENT+ns, function() {
          if(mfp.currItem.type === 'image' && imgSt.cursor) {
            _body.addClass(imgSt.cursor);
          }
        });

        _mfpOn(CLOSE_EVENT+ns, function() {
          if(imgSt.cursor) {
            _body.removeClass(imgSt.cursor);
          }
          _window.off('resize' + EVENT_NS);
        });

        _mfpOn('Resize'+ns, mfp.resizeImage);
        if(mfp.isLowIE) {
          _mfpOn('AfterChange', mfp.resizeImage);
        }
      },
      resizeImage: function() {
        var item = mfp.currItem;
        if(!item || !item.img) return;

        if(mfp.st.image.verticalFit) {
          var decr = 0;
          // fix box-sizing in ie7/8
          if(mfp.isLowIE) {
            decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'),10);
          }
          item.img.css('max-height', mfp.wH-decr);
        }
      },
      _onImageHasSize: function(item) {
        if(item.img) {

          item.hasSize = true;

          if(_imgInterval) {
            clearInterval(_imgInterval);
          }

          item.isCheckingImgSize = false;

          _mfpTrigger('ImageHasSize', item);

          if(item.imgHidden) {
            if(mfp.content)
              mfp.content.removeClass('mfp-loading');

            item.imgHidden = false;
          }

        }
      },

      /**
       * Function that loops until the image has size to display elements that rely on it asap
       */
      findImageSize: function(item) {

        var counter = 0,
          img = item.img[0],
          mfpSetInterval = function(delay) {

            if(_imgInterval) {
              clearInterval(_imgInterval);
            }
            // decelerating interval that checks for size of an image
            _imgInterval = setInterval(function() {
              if(img.naturalWidth > 0) {
                mfp._onImageHasSize(item);
                return;
              }

              if(counter > 200) {
                clearInterval(_imgInterval);
              }

              counter++;
              if(counter === 3) {
                mfpSetInterval(10);
              } else if(counter === 40) {
                mfpSetInterval(50);
              } else if(counter === 100) {
                mfpSetInterval(500);
              }
            }, delay);
          };

        mfpSetInterval(1);
      },

      getImage: function(item, template) {

        var guard = 0,

          // image load complete handler
          onLoadComplete = function() {
            if(item) {
              if (item.img[0].complete) {
                item.img.off('.mfploader');

                if(item === mfp.currItem){
                  mfp._onImageHasSize(item);

                  mfp.updateStatus('ready');
                }

                item.hasSize = true;
                item.loaded = true;

                _mfpTrigger('ImageLoadComplete');

              }
              else {
                // if image complete check fails 200 times (20 sec), we assume that there was an error.
                guard++;
                if(guard < 200) {
                  setTimeout(onLoadComplete,100);
                } else {
                  onLoadError();
                }
              }
            }
          },

          // image error handler
          onLoadError = function() {
            if(item) {
              item.img.off('.mfploader');
              if(item === mfp.currItem){
                mfp._onImageHasSize(item);
                mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
              }

              item.hasSize = true;
              item.loaded = true;
              item.loadError = true;
            }
          },
          imgSt = mfp.st.image;


        var el = template.find('.mfp-img');
        if(el.length) {
          var img = document.createElement('img');
          img.className = 'mfp-img';
          if(item.el && item.el.find('img').length) {
            img.alt = item.el.find('img').attr('alt');
          }
          item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
          img.src = item.src;

          // without clone() "error" event is not firing when IMG is replaced by new IMG
          // TODO: find a way to avoid such cloning
          if(el.is('img')) {
            item.img = item.img.clone();
          }

          img = item.img[0];
          if(img.naturalWidth > 0) {
            item.hasSize = true;
          } else if(!img.width) {
            item.hasSize = false;
          }
        }

        mfp._parseMarkup(template, {
          title: _getTitle(item),
          img_replaceWith: item.img
        }, item);

        mfp.resizeImage();

        if(item.hasSize) {
          if(_imgInterval) clearInterval(_imgInterval);

          if(item.loadError) {
            template.addClass('mfp-loading');
            mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
          } else {
            template.removeClass('mfp-loading');
            mfp.updateStatus('ready');
          }
          return template;
        }

        mfp.updateStatus('loading');
        item.loading = true;

        if(!item.hasSize) {
          item.imgHidden = true;
          template.addClass('mfp-loading');
          mfp.findImageSize(item);
        }

        return template;
      }
    }
  });



  /*>>image*/

  /*>>zoom*/
  var hasMozTransform,
    getHasMozTransform = function() {
      if(hasMozTransform === undefined) {
        hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
      }
      return hasMozTransform;
    };

  $.magnificPopup.registerModule('zoom', {

    options: {
      enabled: false,
      easing: 'ease-in-out',
      duration: 300,
      opener: function(element) {
        return element.is('img') ? element : element.find('img');
      }
    },

    proto: {

      initZoom: function() {
        var zoomSt = mfp.st.zoom,
          ns = '.zoom',
          image;

        if(!zoomSt.enabled || !mfp.supportsTransition) {
          return;
        }

        var duration = zoomSt.duration,
          getElToAnimate = function(image) {
            var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'),
              transition = 'all '+(zoomSt.duration/1000)+'s ' + zoomSt.easing,
              cssObj = {
                position: 'fixed',
                zIndex: 9999,
                left: 0,
                top: 0,
                '-webkit-backface-visibility': 'hidden'
              },
              t = 'transition';

            cssObj['-webkit-'+t] = cssObj['-moz-'+t] = cssObj['-o-'+t] = cssObj[t] = transition;

            newImg.css(cssObj);
            return newImg;
          },
          showMainContent = function() {
            mfp.content.css('visibility', 'visible');
          },
          openTimeout,
          animatedImg;

        _mfpOn('BuildControls'+ns, function() {
          if(mfp._allowZoom()) {

            clearTimeout(openTimeout);
            mfp.content.css('visibility', 'hidden');

            // Basically, all code below does is clones existing image, puts in on top of the current one and animated it

            image = mfp._getItemToZoom();

            if(!image) {
              showMainContent();
              return;
            }

            animatedImg = getElToAnimate(image);

            animatedImg.css( mfp._getOffset() );

            mfp.wrap.append(animatedImg);

            openTimeout = setTimeout(function() {
              animatedImg.css( mfp._getOffset( true ) );
              openTimeout = setTimeout(function() {

                showMainContent();

                setTimeout(function() {
                  animatedImg.remove();
                  image = animatedImg = null;
                  _mfpTrigger('ZoomAnimationEnded');
                }, 16); // avoid blink when switching images

              }, duration); // this timeout equals animation duration

            }, 16); // by adding this timeout we avoid short glitch at the beginning of animation


            // Lots of timeouts...
          }
        });
        _mfpOn(BEFORE_CLOSE_EVENT+ns, function() {
          if(mfp._allowZoom()) {

            clearTimeout(openTimeout);

            mfp.st.removalDelay = duration;

            if(!image) {
              image = mfp._getItemToZoom();
              if(!image) {
                return;
              }
              animatedImg = getElToAnimate(image);
            }


            animatedImg.css( mfp._getOffset(true) );
            mfp.wrap.append(animatedImg);
            mfp.content.css('visibility', 'hidden');

            setTimeout(function() {
              animatedImg.css( mfp._getOffset() );
            }, 16);
          }

        });

        _mfpOn(CLOSE_EVENT+ns, function() {
          if(mfp._allowZoom()) {
            showMainContent();
            if(animatedImg) {
              animatedImg.remove();
            }
            image = null;
          }
        });
      },

      _allowZoom: function() {
        return mfp.currItem.type === 'image';
      },

      _getItemToZoom: function() {
        if(mfp.currItem.hasSize) {
          return mfp.currItem.img;
        } else {
          return false;
        }
      },

      // Get element postion relative to viewport
      _getOffset: function(isLarge) {
        var el;
        if(isLarge) {
          el = mfp.currItem.img;
        } else {
          el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
        }

        var offset = el.offset();
        var paddingTop = parseInt(el.css('padding-top'),10);
        var paddingBottom = parseInt(el.css('padding-bottom'),10);
        offset.top -= ( $(window).scrollTop() - paddingTop );


        /*

			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
        var obj = {
          width: el.width(),
          // fix Zepto height+padding issue
          height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
        };

        // I hate to do this, but there is no another option
        if( getHasMozTransform() ) {
          obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
        } else {
          obj.left = offset.left;
          obj.top = offset.top;
        }
        return obj;
      }

    }
  });



  /*>>zoom*/

  /*>>iframe*/

  var IFRAME_NS = 'iframe',
    _emptyPage = '//about:blank',

    _fixIframeBugs = function(isShowing) {
      if(mfp.currTemplate[IFRAME_NS]) {
        var el = mfp.currTemplate[IFRAME_NS].find('iframe');
        if(el.length) {
          // reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
          if(!isShowing) {
            el[0].src = _emptyPage;
          }

          // IE8 black screen bug fix
          if(mfp.isIE8) {
            el.css('display', isShowing ? 'block' : 'none');
          }
        }
      }
    };

  $.magnificPopup.registerModule(IFRAME_NS, {

    options: {
      markup: '<div class="mfp-iframe-scaler">'+
      '<div class="mfp-close"></div>'+
      '<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>'+
      '</div>',

      srcAction: 'iframe_src',

      // we don't care and support only one default type of URL by default
      patterns: {
        youtube: {
          index: 'youtube.com',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?autoplay=1'
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      }
    },

    proto: {
      initIframe: function() {
        mfp.types.push(IFRAME_NS);

        _mfpOn('BeforeChange', function(e, prevType, newType) {
          if(prevType !== newType) {
            if(prevType === IFRAME_NS) {
              _fixIframeBugs(); // iframe if removed
            } else if(newType === IFRAME_NS) {
              _fixIframeBugs(true); // iframe is showing
            }
          }// else {
          // iframe source is switched, don't do anything
          //}
        });

        _mfpOn(CLOSE_EVENT + '.' + IFRAME_NS, function() {
          _fixIframeBugs();
        });
      },

      getIframe: function(item, template) {
        var embedSrc = item.src;
        var iframeSt = mfp.st.iframe;

        $.each(iframeSt.patterns, function() {
          if(embedSrc.indexOf( this.index ) > -1) {
            if(this.id) {
              if(typeof this.id === 'string') {
                embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id)+this.id.length, embedSrc.length);
              } else {
                embedSrc = this.id.call( this, embedSrc );
              }
            }
            embedSrc = this.src.replace('%id%', embedSrc );
            return false; // break;
          }
        });

        var dataObj = {};
        if(iframeSt.srcAction) {
          dataObj[iframeSt.srcAction] = embedSrc;
        }
        mfp._parseMarkup(template, dataObj, item);

        mfp.updateStatus('ready');

        return template;
      }
    }
  });



  /*>>iframe*/

  /*>>gallery*/
  /**
   * Get looped index depending on number of slides
   */
  var _getLoopedId = function(index) {
      var numSlides = mfp.items.length;
      if(index > numSlides - 1) {
        return index - numSlides;
      } else  if(index < 0) {
        return numSlides + index;
      }
      return index;
    },
    _replaceCurrTotal = function(text, curr, total) {
      return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
    };

  $.magnificPopup.registerModule('gallery', {

    options: {
      enabled: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0,2],
      navigateByImgClick: true,
      arrows: true,

      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      tCounter: '%curr% of %total%'
    },

    proto: {
      initGallery: function() {

        var gSt = mfp.st.gallery,
          ns = '.mfp-gallery',
          supportsFastClick = Boolean($.fn.mfpFastClick);

        mfp.direction = true; // true - next, false - prev

        if(!gSt || !gSt.enabled ) return false;

        _wrapClasses += ' mfp-gallery';

        _mfpOn(OPEN_EVENT+ns, function() {

          if(gSt.navigateByImgClick) {
            mfp.wrap.on('click'+ns, '.mfp-img', function() {
              if(mfp.items.length > 1) {
                mfp.next();
                return false;
              }
            });
          }

          _document.on('keydown'+ns, function(e) {
            if (e.keyCode === 37) {
              mfp.prev();
            } else if (e.keyCode === 39) {
              mfp.next();
            }
          });
        });

        _mfpOn('UpdateStatus'+ns, function(e, data) {
          if(data.text) {
            data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
          }
        });

        _mfpOn(MARKUP_PARSE_EVENT+ns, function(e, element, values, item) {
          var l = mfp.items.length;
          values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
        });

        _mfpOn('BuildControls' + ns, function() {
          if(mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
            var markup = gSt.arrowMarkup,
              arrowLeft = mfp.arrowLeft = $( markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, 'left') ).addClass(PREVENT_CLOSE_CLASS),
              arrowRight = mfp.arrowRight = $( markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, 'right') ).addClass(PREVENT_CLOSE_CLASS);

            var eName = supportsFastClick ? 'mfpFastClick' : 'click';
            arrowLeft[eName](function() {
              mfp.prev();
            });
            arrowRight[eName](function() {
              mfp.next();
            });

            // Polyfill for :before and :after (adds elements with classes mfp-a and mfp-b)
            if(mfp.isIE7) {
              _getEl('b', arrowLeft[0], false, true);
              _getEl('a', arrowLeft[0], false, true);
              _getEl('b', arrowRight[0], false, true);
              _getEl('a', arrowRight[0], false, true);
            }

            mfp.container.append(arrowLeft.add(arrowRight));
          }
        });

        _mfpOn(CHANGE_EVENT+ns, function() {
          if(mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

          mfp._preloadTimeout = setTimeout(function() {
            mfp.preloadNearbyImages();
            mfp._preloadTimeout = null;
          }, 16);
        });


        _mfpOn(CLOSE_EVENT+ns, function() {
          _document.off(ns);
          mfp.wrap.off('click'+ns);

          if(mfp.arrowLeft && supportsFastClick) {
            mfp.arrowLeft.add(mfp.arrowRight).destroyMfpFastClick();
          }
          mfp.arrowRight = mfp.arrowLeft = null;
        });

      },
      next: function() {
        mfp.direction = true;
        mfp.index = _getLoopedId(mfp.index + 1);
        mfp.updateItemHTML();
      },
      prev: function() {
        mfp.direction = false;
        mfp.index = _getLoopedId(mfp.index - 1);
        mfp.updateItemHTML();
      },
      goTo: function(newIndex) {
        mfp.direction = (newIndex >= mfp.index);
        mfp.index = newIndex;
        mfp.updateItemHTML();
      },
      preloadNearbyImages: function() {
        var p = mfp.st.gallery.preload,
          preloadBefore = Math.min(p[0], mfp.items.length),
          preloadAfter = Math.min(p[1], mfp.items.length),
          i;

        for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
          mfp._preloadItem(mfp.index+i);
        }
        for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
          mfp._preloadItem(mfp.index-i);
        }
      },
      _preloadItem: function(index) {
        index = _getLoopedId(index);

        if(mfp.items[index].preloaded) {
          return;
        }

        var item = mfp.items[index];
        if(!item.parsed) {
          item = mfp.parseEl( index );
        }

        _mfpTrigger('LazyLoad', item);

        if(item.type === 'image') {
          item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
            item.hasSize = true;
          }).on('error.mfploader', function() {
            item.hasSize = true;
            item.loadError = true;
            _mfpTrigger('LazyLoadError', item);
          }).attr('src', item.src);
        }


        item.preloaded = true;
      }
    }
  });

  /*
Touch Support that might be implemented some day

addSwipeGesture: function() {
	var startX,
		moved,
		multipleTouches;

		return;

	var namespace = '.mfp',
		addEventNames = function(pref, down, move, up, cancel) {
			mfp._tStart = pref + down + namespace;
			mfp._tMove = pref + move + namespace;
			mfp._tEnd = pref + up + namespace;
			mfp._tCancel = pref + cancel + namespace;
		};

	if(window.navigator.msPointerEnabled) {
		addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
	} else if('ontouchstart' in window) {
		addEventNames('touch', 'start', 'move', 'end', 'cancel');
	} else {
		return;
	}
	_window.on(mfp._tStart, function(e) {
		var oE = e.originalEvent;
		multipleTouches = moved = false;
		startX = oE.pageX || oE.changedTouches[0].pageX;
	}).on(mfp._tMove, function(e) {
		if(e.originalEvent.touches.length > 1) {
			multipleTouches = e.originalEvent.touches.length;
		} else {
			//e.preventDefault();
			moved = true;
		}
	}).on(mfp._tEnd + ' ' + mfp._tCancel, function(e) {
		if(moved && !multipleTouches) {
			var oE = e.originalEvent,
				diff = startX - (oE.pageX || oE.changedTouches[0].pageX);

			if(diff > 20) {
				mfp.next();
			} else if(diff < -20) {
				mfp.prev();
			}
		}
	});
},
*/


  /*>>gallery*/

  /*>>retina*/

  var RETINA_NS = 'retina';

  $.magnificPopup.registerModule(RETINA_NS, {
    options: {
      replaceSrc: function(item) {
        return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
      },
      ratio: 1 // Function or number.  Set to 1 to disable.
    },
    proto: {
      initRetina: function() {
        if(window.devicePixelRatio > 1) {

          var st = mfp.st.retina,
            ratio = st.ratio;

          ratio = !isNaN(ratio) ? ratio : ratio();

          if(ratio > 1) {
            _mfpOn('ImageHasSize' + '.' + RETINA_NS, function(e, item) {
              item.img.css({
                'max-width': item.img[0].naturalWidth / ratio,
                'width': '100%'
              });
            });
            _mfpOn('ElementParse' + '.' + RETINA_NS, function(e, item) {
              item.src = st.replaceSrc(item, ratio);
            });
          }
        }

      }
    }
  });

  /*>>retina*/

  /*>>fastclick*/
  /**
   * FastClick event implementation. (removes 300ms delay on touch devices)
   * Based on https://developers.google.com/mobile/articles/fast_buttons
   *
   * You may use it outside the Magnific Popup by calling just:
   *
   * $('.your-el').mfpFastClick(function() {
 *	 console.log('Clicked!');
 * });
   *
   * To unbind:
   * $('.your-el').destroyMfpFastClick();
   *
   *
   * Note that it's a very basic and simple implementation, it blocks ghost click on the same element where it was bound.
   * If you need something more advanced, use plugin by FT Labs https://github.com/ftlabs/fastclick
   *
   */

  (function() {
    var ghostClickDelay = 1000,
      supportsTouch = 'ontouchstart' in window,
      unbindTouchMove = function() {
        _window.off('touchmove'+ns+' touchend'+ns);
      },
      eName = 'mfpFastClick',
      ns = '.'+eName;


    // As Zepto.js doesn't have an easy way to add custom events (like jQuery), so we implement it in this way
    $.fn.mfpFastClick = function(callback) {

      return $(this).each(function() {

        var elem = $(this),
          lock;

        if( supportsTouch ) {

          var timeout,
            startX,
            startY,
            pointerMoved,
            point,
            numPointers;

          elem.on('touchstart' + ns, function(e) {
            pointerMoved = false;
            numPointers = 1;

            point = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0];
            startX = point.clientX;
            startY = point.clientY;

            _window.on('touchmove'+ns, function(e) {
              point = e.originalEvent ? e.originalEvent.touches : e.touches;
              numPointers = point.length;
              point = point[0];
              if (Math.abs(point.clientX - startX) > 10 ||
                Math.abs(point.clientY - startY) > 10) {
                pointerMoved = true;
                unbindTouchMove();
              }
            }).on('touchend'+ns, function(e) {
              unbindTouchMove();
              if(pointerMoved || numPointers > 1) {
                return;
              }
              lock = true;
              e.preventDefault();
              clearTimeout(timeout);
              timeout = setTimeout(function() {
                lock = false;
              }, ghostClickDelay);
              callback();
            });
          });

        }

        elem.on('click' + ns, function() {
          if(!lock) {
            callback();
          }
        });
      });
    };

    $.fn.destroyMfpFastClick = function() {
      $(this).off('touchstart' + ns + ' click' + ns);
      if(supportsTouch) _window.off('touchmove'+ns+' touchend'+ns);
    };
  })();

  /*>>fastclick*/
  _checkInstance(); }));


/* ==========================================================================
   13. vide.js
   ========================================================================== */
/*
 *  Vide - v0.3.0
 *  Easy as hell jQuery plugin for video backgrounds.
 *  http://vodkabears.github.io/vide/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */

!(function($, window, document, navigator) {
  "use strict";

  /**
   * Vide settings
   * @private
   */
  var pluginName = "vide",
    defaults = {
      volume: 1,
      playbackRate: 1,
      muted: true,
      loop: true,
      autoplay: true,
      position: "50% 50%",
      posterType: "detect",
      resizing: true
    },

    // is iOs?
    isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent),

    // is Android?
    isAndroid = /Android/i.test(navigator.userAgent);

  /**
   * Parse string with options
   * @param {String} str
   * @returns {Object|String}
   * @private
   */
  function parseOptions(str) {
    var obj = {},
      delimiterIndex,
      option,
      prop, val,
      arr, len,
      i;

    // remove spaces around delimiters and split
    arr = str.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ",").split(",");

    // parse string
    for (i = 0, len = arr.length; i < len; i++) {
      option = arr[i];

      // Ignore urls and string without colon delimiters
      if (option.search(/^(http|https|ftp):\/\//) !== -1 ||
        option.search(":") === -1)
      {
        break;
      }

      delimiterIndex = option.indexOf(":");
      prop = option.substring(0, delimiterIndex);
      val = option.substring(delimiterIndex + 1);

      // if val is an empty string, make it undefined
      if (!val) {
        val = undefined;
      }

      // convert string value if it is like a boolean
      if (typeof val === "string") {
        val = val === "true" || (val === "false" ? false : val);
      }

      // convert string value if it is like a number
      if (typeof val === "string") {
        val = !isNaN(val) ? +val : val;
      }

      obj[prop] = val;
    }

    // if nothing is parsed
    if (prop == null && val == null) {
      return str;
    }

    return obj;
  }

  /**
   * Parse position option
   * @param {String} str
   * @returns {Object}
   * @private
   */
  function parsePosition(str) {
    str = "" + str;

    // default value is a center
    var args = str.split(/\s+/),
      x = "50%", y = "50%",
      len, arg,
      i;

    for (i = 0, len = args.length; i < len; i++) {
      arg = args[i];

      // convert values
      if (arg === "left") {
        x = "0%";
      } else if (arg === "right") {
        x = "100%";
      } else if (arg === "top") {
        y = "0%";
      } else if (arg === "bottom") {
        y = "100%";
      } else if (arg === "center") {
        if (i === 0) {
          x = "50%";
        } else {
          y = "50%";
        }
      } else {
        if (i === 0) {
          x = arg;
        } else {
          y = arg;
        }
      }
    }

    return { x: x, y: y };
  }

  /**
   * Search poster
   * @param {String} path
   * @param {Function} callback
   * @private
   */
  function findPoster(path, callback) {
    var onLoad = function() {
      callback(this.src);
    };

    $("<img src='" + path + ".gif'>").load(onLoad);
    $("<img src='" + path + ".jpg'>").load(onLoad);
    $("<img src='" + path + ".jpeg'>").load(onLoad);
    $("<img src='" + path + ".png'>").load(onLoad);
  }

  /**
   * Vide constructor
   * @param {HTMLElement} element
   * @param {Object|String} path
   * @param {Object|String} options
   * @constructor
   */
  function Vide(element, path, options) {
    this.$element = $(element);

    // parse path
    if (typeof path === "string") {
      path = parseOptions(path);
    }

    // parse options
    if (!options) {
      options = {};
    } else if (typeof options === "string") {
      options = parseOptions(options);
    }

    // remove extension
    if (typeof path === "string") {
      path = path.replace(/\.\w*$/, "");
    } else if (typeof path === "object") {
      for (var i in path) {
        if (path.hasOwnProperty(i)) {
          path[i] = path[i].replace(/\.\w*$/, "");
        }
      }
    }

    this.settings = $.extend({}, defaults, options);
    this.path = path;

    this.init();
  }

  /**
   * Initialization
   * @public
   */
  Vide.prototype.init = function() {
    var vide = this,
      position = parsePosition(vide.settings.position),
      sources,
      poster;

    // Set video wrapper styles
    vide.$wrapper = $("<div>").css({
      "position": "absolute",
      "z-index": -1,
      "top": 0,
      "left": 0,
      "bottom": 0,
      "right": 0,
      "overflow": "hidden",
      "-webkit-background-size": "cover",
      "-moz-background-size": "cover",
      "-o-background-size": "cover",
      "background-size": "cover",
      "background-repeat": "no-repeat",
      "background-position": position.x + " " + position.y
    });

    // Get poster path
    poster = vide.path;
    if (typeof vide.path === "object") {
      if (vide.path.poster) {
        poster = vide.path.poster;
      } else {
        if (vide.path.mp4) {
          poster = vide.path.mp4;
        } else if (vide.path.webm) {
          poster = vide.path.webm;
        } else if (vide.path.ogv) {
          poster = vide.path.ogv;
        }
      }
    }

    // Set video poster
    if (vide.settings.posterType === "detect") {
      findPoster(poster, function(url) {
        vide.$wrapper.css("background-image", "url(" + url + ")");
      });
    } else if (vide.settings.posterType !== "none") {
      vide.$wrapper
        .css("background-image", "url(" + poster + "." + vide.settings.posterType + ")");
    }

    // if parent element has a static position, make it relative
    if (vide.$element.css("position") === "static") {
      vide.$element.css("position", "relative");
    }

    vide.$element.prepend(vide.$wrapper);

    if (!isIOS && !isAndroid) {
      sources = "";

      if (typeof vide.path === "object") {
        if (vide.path.mp4) {
          sources += "<source src='" + vide.path.mp4 + ".mp4' type='video/mp4'>";
        }
        if (vide.path.webm) {
          sources += "<source src='" + vide.path.webm + ".webm' type='video/webm'>";
        }
        if (vide.path.ogv) {
          sources += "<source src='" + vide.path.ogv + ".ogv' type='video/ogv'>";
        }

        vide.$video = $("<video>" + sources + "</video>");
      } else {
        vide.$video = $("<video>" +
          "<source src='" + vide.path + ".mp4' type='video/mp4'>" +
          "<source src='" + vide.path + ".webm' type='video/webm'>" +
          "<source src='" + vide.path + ".ogv' type='video/ogg'>" +
          "</video>");
      }

      // Disable visibility, while loading
      vide.$video.css("visibility", "hidden");

      // Set video properties
      vide.$video.prop({
        autoplay: vide.settings.autoplay,
        loop: vide.settings.loop,
        volume: vide.settings.volume,
        muted: vide.settings.muted,
        playbackRate: vide.settings.playbackRate
      });

      // Append video
      vide.$wrapper.append(vide.$video);

      // Video alignment
      vide.$video.css({
        "margin": "auto",
        "position": "absolute",
        "z-index": -1,
        "top": position.y,
        "left": position.x,
        "-webkit-transform": "translate(-" + position.x + ", -" + position.y + ")",
        "-ms-transform": "translate(-" + position.x + ", -" + position.y + ")",
        "transform": "translate(-" + position.x + ", -" + position.y + ")"
      });

      // resize video, when it's loaded
      vide.$video.bind("loadedmetadata." + pluginName, function() {
        vide.$video.css("visibility", "visible");
        vide.resize();
        vide.$wrapper.css("background-image", "none");
      });

      // resize event is available only for 'window',
      // use another code solutions to detect DOM elements resizing
      vide.$element.bind("resize." + pluginName, function() {
        if (vide.settings.resizing) {
          vide.resize();
        }
      });
    }
  };

  /**
   * Get video element of the background
   * @returns {HTMLVideoElement|null}
   * @public
   */
  Vide.prototype.getVideoObject = function() {
    return this.$video ? this.$video[0] : null;
  };

  /**
   * Resize video background
   * @public
   */
  Vide.prototype.resize = function() {
    if (!this.$video) {
      return;
    }

    var
      // get native video size
      videoHeight = this.$video[0].videoHeight,
      videoWidth = this.$video[0].videoWidth,

      // get wrapper size
      wrapperHeight = this.$wrapper.height(),
      wrapperWidth = this.$wrapper.width();

    if (wrapperWidth / videoWidth > wrapperHeight / videoHeight) {
      this.$video.css({
        "width": wrapperWidth + 2,

        // +2 pixels to prevent empty space after transformation
        "height": "auto"
      });
    } else {
      this.$video.css({
        "width": "auto",

        // +2 pixels to prevent empty space after transformation
        "height": wrapperHeight + 2
      });
    }
  };

  /**
   * Destroy video background
   * @public
   */
  Vide.prototype.destroy = function() {
    this.$element.unbind(pluginName);

    if (this.$video) {
      this.$video.unbind(pluginName);
    }

    delete $[pluginName].lookup[this.index];
    this.$element.removeData(pluginName);
    this.$wrapper.remove();
  };

  /**
   * Special plugin object for instances.
   * @type {Object}
   * @public
   */
  $[pluginName] = {
    lookup: []
  };

  /**
   * Plugin constructor
   * @param {Object|String} path
   * @param {Object|String} options
   * @returns {JQuery}
   * @constructor
   */
  $.fn[pluginName] = function(path, options) {
    var instance;

    this.each(function() {
      instance = $.data(this, pluginName);

      if (instance) {

        // destroy plugin instance if exists
        instance.destroy();
      }

      // create plugin instance
      instance = new Vide(this, path, options);
      instance.index = $[pluginName].lookup.push(instance) - 1;
      $.data(this, pluginName, instance);
    });

    return this;
  };

  $(document).ready(function() {

    // window resize event listener
    $(window).bind("resize." + pluginName, function() {
      for (var len = $[pluginName].lookup.length, i = 0, instance; i < len; i++) {
        instance = $[pluginName].lookup[i];

        if (instance && instance.settings.resizing) {
          instance.resize();
        }
      }
    });

    // Auto initialization.
    // Add 'data-vide-bg' attribute with a path to the video without extension.
    // Also you can pass options throw the 'data-vide-options' attribute.
    // 'data-vide-options' must be like "muted: false, volume: 0.5".
    $(document).find("[data-" + pluginName + "-bg]").each(function(i, element) {
      var $element = $(element),
        options = $element.data(pluginName + "-options"),
        path = $element.data(pluginName + "-bg");

      $element[pluginName](path, options);
    });
  });
})(window.jQuery, window, document, navigator);


/* ==========================================================================
   14. theme.js
   ========================================================================== */
/*
Name: 			Theme Base
Written by: 	Okler Themes - (http://www.okler.net)
Theme Version:	3.7.0
*/

// Theme
window.theme = {};

// Animate
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__animate';

  var PluginAnimate = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginAnimate.defaults = {
    accX: 0,
    accY: -150,
    delay: 1
  };

  PluginAnimate.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginAnimate.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      var self = this,
        $el = this.options.wrapper,
        delay = 0;

      $el.addClass('appear-animation');

      if (!$('html').hasClass('no-csstransitions') && $(window).width() > 767) {

        $el.appear(function() {

          delay = ($el.attr('data-appear-animation-delay') ? $el.attr('data-appear-animation-delay') : self.options.delay);

          if (delay > 1) {
            $el.css('animation-delay', delay + 'ms');
          }

          $el.addClass($el.attr('data-appear-animation'));

          setTimeout(function() {
            $el.addClass('appear-animation-visible');
          }, delay);

        }, {
          accX: self.options.accX,
          accY: self.options.accY
        });

      } else {

        $el.addClass('appear-animation-visible');

      }

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginAnimate: PluginAnimate
  });

  // jquery plugin
  $.fn.themePluginAnimate = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginAnimate($this, opts);
      }

    });
  };

}).apply(this, [window.theme, jQuery]);

// Chart Circular
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__chartCircular';

  var PluginChartCircular = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginChartCircular.defaults = {
    accX: 0,
    accY: -150,
    delay: 1,
    barColor: '#0088CC',
    trackColor: '#f2f2f2',
    scaleColor: false,
    scaleLength: 5,
    lineCap: 'round',
    lineWidth: 13,
    size: 175,
    rotate: 0,
    animate: ({
      duration: 2500,
      enabled: true
    })
  };

  PluginChartCircular.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginChartCircular.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.appear)) || !($.isFunction($.fn.easyPieChart))) {
        return this;
      }

      var self = this,
        $el = this.options.wrapper,
        value = ($el.attr('data-percent') ? $el.attr('data-percent') : 0),
        percentEl = $el.find('.percent');

      $.extend(true, self.options, {
        onStep: function(from, to, currentValue) {
          percentEl.html(parseInt(currentValue));
        }
      });

      $el.attr('data-percent', 0);

      $el.appear(function() {

        $el.easyPieChart(self.options);

        setTimeout(function() {

          $el.data('easyPieChart').update(value);
          $el.attr('data-percent', value);

        }, self.options.delay);

      }, {
        accX: self.options.accX,
        accY: self.options.accY
      });

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginChartCircular: PluginChartCircular
  });

  // jquery plugin
  $.fn.themePluginChartCircular = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginChartCircular($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Counter
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__counter';

  var PluginCounter = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginCounter.defaults = {
    accX: 0,
    accY: 0,
    speed: 3000,
    refreshInterval: 100,
    decimals: 0,
    onUpdate: null,
    onComplete: null
  };

  PluginCounter.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginCounter.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.countTo))) {
        return this;
      }

      var self = this,
        $el = this.options.wrapper;

      $.extend(self.options, {
        onComplete: function() {
          if ($el.data('append')) {
            $el.html($el.html() + $el.data('append'));
          }

          if ($el.data('prepend')) {
            $el.html($el.data('prepend') + $el.html());
          }
        }
      });

      $el.appear(function() {

        $el.countTo(self.options);

      }, {
        accX: self.options.accX,
        accY: self.options.accY
      });

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginCounter: PluginCounter
  });

  // jquery plugin
  $.fn.themePluginCounter = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginCounter($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Flickr
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__flickr';

  var PluginFlickr = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginFlickr.defaults = {
    flickrbase: 'http://api.flickr.com/services/feeds/',
    feedapi: 'photos_public.gne',
    limit: 6,
    qstrings: {
      lang: 'en-us',
      format: 'json',
      jsoncallback: '?'
    },
    cleanDescription: true,
    useTemplate: true,
    itemTemplate: '<li><a href="{{image_b}}" title="{{title}}"><span class="thumbnail"><img src="{{image_s}}" /></span></a></li>',
    itemCallback: function() {}
  };

  PluginFlickr.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginFlickr.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.jflickrfeed)) || !($.isFunction($.fn.magnificPopup))) {
        return this;
      }

      var self = this;

      self.options.wrapper.jflickrfeed(this.options, function(data) {

        self.options.wrapper.magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1]
          },
          zoom: {
            enabled: true,
            duration: 300,
            opener: function(element) {
              return element.find('img');
            }
          }
        });

      });

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginFlickr: PluginFlickr
  });

  // jquery plugin
  $.fn.themePluginFlickr = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginFlickr($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Lightbox
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__lightbox';

  var PluginLightbox = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginLightbox.defaults = {
    tClose: 'Close (Esc)', // Alt text on close button
    tLoading: 'Loading...', // Text that is displayed during loading. Can contain %curr% and %total% keys
    gallery: {
      tPrev: 'Previous (Left arrow key)', // Alt text on left arrow
      tNext: 'Next (Right arrow key)', // Alt text on right arrow
      tCounter: '%curr% of %total%' // Markup for "1 of 7" counter
    },
    image: {
      tError: '<a href="%url%">The image</a> could not be loaded.' // Error message when image could not be loaded
    },
    ajax: {
      tError: '<a href="%url%">The content</a> could not be loaded.' // Error message when ajax request failed
    }
  };

  PluginLightbox.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginLightbox.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.magnificPopup))) {
        return this;
      }

      this.options.wrapper.magnificPopup(this.options);

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginLightbox: PluginLightbox
  });

  // jquery plugin
  $.fn.themePluginLightbox = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginLightbox($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Masonry
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__masonry';

  var PluginMasonry = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginMasonry.defaults = {
    itemSelector: 'li',
    layoutMode: 'fitRows'
  };

  PluginMasonry.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginMasonry.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.isotope))) {
        return this;
      }

      this.options.wrapper.isotope(this.options);

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginMasonry: PluginMasonry
  });

  // jquery plugin
  $.fn.themePluginMasonry = function(opts) {
    return this.map(function() {
      var $this = $(this);

      $this.waitForImages(function() {
        if ($this.data(instanceName)) {
          return $this.data(instanceName);
        } else {
          return new PluginMasonry($this, opts);
        }
      });

    });
  }

}).apply(this, [window.theme, jQuery]);

// Parallax
(function(theme, $) {

  theme = theme || {};

  $.extend(theme, {

    PluginParallax: {

      defaults: {
        itemsSelector: '.parallax',
        horizontalScrolling: false
      },

      initialize: function(opts) {

        this
          .setOptions(opts)
          .build();

        return this;
      },

      setOptions: function(opts) {
        this.options = $.extend(true, {}, this.defaults, opts);

        return this;
      },

      build: function() {
        if (!($.isFunction($.fn.stellar)) || ("ontouchstart" in document.documentElement)) {
          return this;
        }

        var self = this;

        window.addEventListener('load', function(event) {

          if ("ontouchstart" in document.documentElement) {
            $(self.options.itemsSelector).addClass('parallax-disabled');
          } else {
            //$.stellar(self.options).addClass('parallax-ready');
          }

        });

        return this;
      }

    }

  });

}).apply(this, [window.theme, jQuery]);

// Progress Bar
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__progressBar';

  var PluginProgressBar = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginProgressBar.defaults = {
    accX: 0,
    accY: -50,
    delay: 1
  };

  PluginProgressBar.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginProgressBar.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.appear))) {
        return this;
      }

      var self = this,
        $el = this.options.wrapper,
        delay = 1;

      $el.appear(function() {

        delay = ($el.attr('data-appear-animation-delay') ? $el.attr('data-appear-animation-delay') : self.options.delay);

        $el.addClass($el.attr('data-appear-animation'));

        setTimeout(function() {

          $el.animate({
            width: $el.attr('data-appear-progress-animation')
          }, 1500, 'easeOutQuad', function() {
            $el.find('.progress-bar-tooltip').animate({
              opacity: 1
            }, 500, 'easeOutQuad');
          });

        }, delay);

      }, {
        accX: self.options.accX,
        accY: self.options.accY
      });

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginProgressBar: PluginProgressBar
  });

  // jquery plugin
  $.fn.themePluginProgressBar = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginProgressBar($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Revolution Slider
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__revolution';

  var PluginRevolutionSlider = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginRevolutionSlider.defaults = {
    dottedOverlay: 'none',
    delay: 9000,
    startwidth: 1170,
    startheight: 500,
    hideThumbs: 200,

    thumbWidth: 100,
    thumbHeight: 50,
    thumbAmount: 3,

    navigationType: 'none',
    navigationArrows: 'solo',
    navigationStyle: 'round',

    touchenabled: 'on',
    onHoverStop: 'on',

    swipe_velocity: 0.7,
    swipe_min_touches: 1,
    swipe_max_touches: 1,
    drag_block_vertical: false,

    keyboardNavigation: 'on',

    navigationHAlign: 'center',
    navigationVAlign: 'bottom',
    navigationHOffset: 0,
    navigationVOffset: 20,

    soloArrowLeftHalign: 'left',
    soloArrowLeftValign: 'center',
    soloArrowLeftHOffset: 20,
    soloArrowLeftVOffset: 0,

    soloArrowRightHalign: 'right',
    soloArrowRightValign: 'center',
    soloArrowRightHOffset: 20,
    soloArrowRightVOffset: 0,

    shadow: 0,
    fullWidth: 'on',
    fullScreen: 'off',

    spinner: 'spinner0',

    stopLoop: 'off',
    stopAfterLoops: -1,
    stopAtSlide: -1,

    shuffle: 'off',

    autoHeight: 'off',
    forceFullWidth: 'off',

    hideThumbsOnMobile: 'off',
    hideNavDelayOnMobile: 1500,
    hideBulletsOnMobile: 'off',
    hideArrowsOnMobile: 'off',
    hideThumbsUnderResolution: 0,

    hideSliderAtLimit: 0,
    hideCaptionAtLimit: 0,
    hideAllCaptionAtLilmit: 0,
    startWithSlide: 0
  };

  PluginRevolutionSlider.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginRevolutionSlider.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.revolution))) {
        return this;
      }

      this.options.wrapper.revolution(this.options);

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginRevolutionSlider: PluginRevolutionSlider
  });

  // jquery plugin
  $.fn.themePluginRevolutionSlider = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginRevolutionSlider($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Scroll to Top
(function(theme, $) {

  theme = theme || {};

  $.extend(theme, {

    PluginScrollToTop: {

      defaults: {
        wrapper: $('body'),
        offset: 150,
        buttonClass: 'scroll-to-top',
        iconClass: 'fa fa-chevron-up',
        delay: 500,
        visibleMobile: false,
        label: false
      },

      initialize: function(opts) {
        initialized = true;

        this
          .setOptions(opts)
          .build()
          .events();

        return this;
      },

      setOptions: function(opts) {
        this.options = $.extend(true, {}, this.defaults, opts);

        return this;
      },

      build: function() {
        var self = this,
          $el;

        // Base HTML Markup
        $el = $('<a />')
          .addClass(self.options.buttonClass)
          .attr({
            'href': '#',
          })
          .append(
            $('<i />')
              .addClass(self.options.iconClass)
          );

        // Visible Mobile
        if (!self.options.visibleMobile) {
          $el.addClass('hidden-mobile');
        }

        // Label
        if (self.options.label) {
          $el.append(
            $('<span />').html(self.options.label)
          );
        }

        this.options.wrapper.append($el);

        this.$el = $el;

        return this;
      },

      events: function() {
        var self = this,
          _isScrolling = false;

        // Click Element Action
        self.$el.on('click', function(e) {
          e.preventDefault();
          $('body, html').animate({
            scrollTop: 0
          }, self.options.delay);
          return false;
        });

        // Show/Hide Button on Window Scroll event.
        $(window).scroll(function() {

          if (!_isScrolling) {

            _isScrolling = true;

            if ($(window).scrollTop() > self.options.offset) {

              self.$el.stop(true, true).addClass('visible');
              _isScrolling = false;

            } else {

              self.$el.stop(true, true).removeClass('visible');
              _isScrolling = false;

            }

          }

        });

        return this;
      }

    }

  });

}).apply(this, [window.theme, jQuery]);

// Sort
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__sort';

  var PluginSort = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginSort.defaults = {
    useHash: true,
    itemSelector: 'li',
    layoutMode: 'masonry',
    filter: '*'
  };

  PluginSort.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginSort.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (!($.isFunction($.fn.isotope))) {
        return this;
      }

      var self = this,
        $source = this.options.wrapper,
        $destination = $('.sort-destination[data-sort-id="' + $source.attr('data-sort-id') + '"]');

      if ($destination.get(0)) {

        self.$source = $source;
        self.$destination = $destination;

        self.setParagraphHeight($destination);

        $(window).load(function() {

          $destination.isotope(self.options).isotope('layout');

          self.$destination.isotope('on', 'layoutComplete', function(isoInstance, laidOutItems) {
            if (self.options.useHash || typeof(isoInstance.options.filter != 'undefined')) {
              if (window.location.hash != '' || isoInstance.options.filter.replace('.', '') != '*') {
                window.location.hash = isoInstance.options.filter.replace('.', '');
              }
            }
          });

          self.events();

        });

      }

      return this;
    },

    events: function() {
      var self = this,
        filter = null;

      self.$source.find('a').click(function(e) {
        e.preventDefault();

        filter = $(this).parent().attr('data-option-value');

        self.setFilter(filter);

        return this;
      });

      if (self.options.useHash) {
        self.hashEvents();
      }

      return this;
    },

    setFilter: function(filter) {
      var self = this;

      if (self.filter == filter) {
        return this;
      }

      self.$source.find('li.active').removeClass('active');
      self.$source.find('li[data-option-value="' + filter + '"]').addClass('active');

      self.$destination.isotope({
        filter: filter
      });

      self.filter = filter;

      return this;
    },

    hashEvents: function() {
      var self = this,
        hash = null,
        hashFilter = null,
        initHashFilter = '.' + location.hash.replace('#', '');

      if (initHashFilter != '.' && initHashFilter != '.*') {
        self.setFilter(initHashFilter);
      }

      $(window).bind('hashchange', function(e) {

        hashFilter = '.' + location.hash.replace('#', '');
        hash = (hashFilter == '.' || hashFilter == '.*' ? '*' : hashFilter);

        self.setFilter(hash);

      });

      return this;
    },

    setParagraphHeight: function() {
      var self = this,
        minParagraphHeight = 0,
        paragraphs = $('span.thumb-info-caption p', self.$destination);

      paragraphs.each(function() {
        if ($(this).height() > minParagraphHeight) {
          minParagraphHeight = ($(this).height() + 10);
        }
      });

      paragraphs.height(minParagraphHeight);

      return this;
    }

  };

  // expose to scope
  $.extend(theme, {
    PluginSort: PluginSort
  });

  // jquery plugin
  $.fn.themePluginSort = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginSort($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Toggle
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__toggle';

  var PluginToggle = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginToggle.defaults = {
    duration: 350,
    isAccordion: false
  };

  PluginToggle.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginToggle.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      var self = this,
        $wrapper = this.options.wrapper,
        $items = $wrapper.find('.toggle'),
        $el = null;

      $items.each(function() {
        $el = $(this);

        if ($el.hasClass('active')) {
          $el.find('> p').addClass('preview-active');
          $el.find('> .toggle-content').slideDown(self.options.duration);
        }

        self.events($el);
      });

      if (self.options.isAccordion) {
        self.options.duration = self.options.duration / 2;
      }

      return this;
    },

    events: function($el) {
      var self = this,
        previewParCurrentHeight = 0,
        previewParAnimateHeight = 0,
        toggleContent = null;

      $el.find('> label').click(function(e) {

        var $this = $(this),
          parentSection = $this.parent(),
          parentWrapper = $this.parents('.toggle'),
          previewPar = null,
          closeElement = null;

        if (self.options.isAccordion && typeof(e.originalEvent) != 'undefined') {
          closeElement = parentWrapper.find('.toggle.active > label');

          if (closeElement[0] == $this[0]) {
            return;
          }
        }

        parentSection.toggleClass('active');

        // Preview Paragraph
        if (parentSection.find('> p').get(0)) {

          previewPar = parentSection.find('> p');
          previewParCurrentHeight = previewPar.css('height');
          previewPar.css('height', 'auto');
          previewParAnimateHeight = previewPar.css('height');
          previewPar.css('height', previewParCurrentHeight);

        }

        // Content
        toggleContent = parentSection.find('> .toggle-content');

        if (parentSection.hasClass('active')) {

          $(previewPar).animate({
            height: previewParAnimateHeight
          }, self.options.duration, function() {
            $(this).addClass('preview-active');
          });

          toggleContent.slideDown(self.options.duration, function() {
            if (closeElement) {
              closeElement.trigger('click');
            }
          });

        } else {

          $(previewPar).animate({
            height: 0
          }, self.options.duration, function() {
            $(this).removeClass('preview-active');
          });

          toggleContent.slideUp(self.options.duration);

        }

      });
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginToggle: PluginToggle
  });

  // jquery plugin
  $.fn.themePluginToggle = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginToggle($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Tweets
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__tweets';

  var PluginTweets = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginTweets.defaults = {
    username: null,
    count: 2,
    URL: 'php/twitter-feed.php'
  };

  PluginTweets.prototype = {
    initialize: function($el, opts) {
      if ($el.data(instanceName)) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginTweets.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      if (this.options.username == null || this.options.username == '') {
        return this;
      }

      var self = this,
        $wrapper = this.options.wrapper;

      $.ajax({
        type: 'GET',
        data: {
          twitter_screen_name: self.options.username,
          tweets_to_display: self.options.count
        },
        url: self.options.URL,
      }).done(function(html) {
        $wrapper.html(html);
      });

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginTweets: PluginTweets
  });

  // jquery plugin
  $.fn.themePluginTweets = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginTweets($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Video Background
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__videobackground';

  var PluginVideoBackground = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginVideoBackground.defaults = {
    overlay: true,
    volume: 1,
    playbackRate: 1,
    muted: true,
    loop: true,
    autoplay: true,
    position: '50% 50%',
    posterType: 'detect'
  };

  PluginVideoBackground.prototype = {
    initialize: function($el, opts) {
      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginVideoBackground.defaults, opts, {
        path: this.$el.data('video-path'),
        wrapper: this.$el
      });

      return this;
    },

    build: function() {

      if (!($.isFunction($.fn.vide)) || (!this.options.path)) {
        return this;
      }

      if (this.options.overlay) {
        this.options.wrapper.prepend(
          $('<div />').addClass('video-overlay')
        );
      }

      this.options.wrapper.vide(this.options.path, this.options);

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginVideoBackground: PluginVideoBackground
  });

  // jquery plugin
  $.fn.themePluginVideoBackground = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginVideoBackground($this, opts);
      }

    });
  }

}).apply(this, [window.theme, jQuery]);

// Word Rotate
(function(theme, $) {

  theme = theme || {};

  var instanceName = '__wordRotate';

  var PluginWordRotate = function($el, opts) {
    return this.initialize($el, opts);
  };

  PluginWordRotate.defaults = {
    delay: 2000,
    animDelay: 300
  };

  PluginWordRotate.prototype = {
    initialize: function($el, opts) {
      if ( $el.data( instanceName ) ) {
        return this;
      }

      this.$el = $el;

      this
        .setData()
        .setOptions(opts)
        .build();

      return this;
    },

    setData: function() {
      this.$el.data(instanceName, this);

      return this;
    },

    setOptions: function(opts) {
      this.options = $.extend(true, {}, PluginWordRotate.defaults, opts, {
        wrapper: this.$el
      });

      return this;
    },

    build: function() {
      var self = this,
        $el = this.options.wrapper,
        itemsWrapper = $el.find(".word-rotate-items"),
        items = itemsWrapper.find("> span"),
        firstItem = items.eq(0),
        firstItemClone = firstItem.clone(),
        currentItem = 1,
        currentTop = 0,
        itemWidth = 0;

      itemsWrapper
        .width(firstItem.width() + "px")
        .append(firstItemClone);

      $el
        .addClass("active");

      setInterval(function() {

        currentTop = (currentItem * $el.height());
        currentItem++;

        if(currentItem <= items.length) {
          itemWidth = items.eq(currentItem-1).width();
        } else {
          itemWidth = items.eq(0).width();
        }

        itemsWrapper.animate({
          top: -(currentTop) + "px",
          width: itemWidth + "px"
        }, self.options.animDelay, "easeOutQuad", function() {

          if(currentItem > items.length) {

            itemsWrapper.css("top", 0);
            currentItem = 1;

          }

        });

      }, self.options.delay);

      return this;
    }
  };

  // expose to scope
  $.extend(theme, {
    PluginWordRotate: PluginWordRotate
  });

  // jquery plugin
  $.fn.themePluginWordRotate = function(opts) {
    return this.map(function() {
      var $this = $(this);

      if ($this.data(instanceName)) {
        return $this.data(instanceName);
      } else {
        return new PluginWordRotate($this, opts);
      }

    });
  }

}).apply(this, [ window.theme, jQuery ]);

// Account
(function(theme, $) {

  theme = theme || {};

  var initialized = false;

  $.extend(theme, {

    Account: {

      defaults: {
        wrapper: $('#headerAccount')
      },

      initialize: function($wrapper, opts) {
        if (initialized) {
          return this;
        }

        initialized = true;
        this.$wrapper = ($wrapper || this.defaults.wrapper);

        this
          .setOptions(opts)
          .events();

        return this;
      },

      setOptions: function(opts) {
        this.options = $.extend(true, {}, this.defaults, opts, this.$wrapper.data('plugin-options'));

        return this;
      },

      events: function() {
        var self = this;

        self.$wrapper.find('input').on('focus', function() {
          self.$wrapper.addClass('open');

          $(document).mouseup(function(e) {
            if (!self.$wrapper.is(e.target) && self.$wrapper.has(e.target).length === 0) {
              self.$wrapper.removeClass('open');
            }
          });
        });

        $('#headerSignUp').on('click', function(e) {
          e.preventDefault();
          self.$wrapper.addClass('signup').removeClass('signin').removeClass('recover');
          self.$wrapper.find('.signup-form input:first').focus();
        });

        $('#headerSignIn').on('click', function(e) {
          e.preventDefault();
          self.$wrapper.addClass('signin').removeClass('signup').removeClass('recover');
          self.$wrapper.find('.signin-form input:first').focus();
        });

        $('#headerRecover').on('click', function(e) {
          e.preventDefault();
          self.$wrapper.addClass('recover').removeClass('signup').removeClass('signin');
          self.$wrapper.find('.recover-form input:first').focus();
        });

        $('#headerRecoverCancel').on('click', function(e) {
          e.preventDefault();
          self.$wrapper.addClass('signin').removeClass('signup').removeClass('recover');
          self.$wrapper.find('.signin-form input:first').focus();
        });
      }

    }

  });

}).apply(this, [window.theme, jQuery]);

// Nav
(function(theme, $) {

  theme = theme || {};

  var initialized = false;

  $.extend(theme, {

    Nav: {

      defaults: {
        wrapper: $('#mainMenu'),
        mobileMenuScroll: true,
        fixParentItems: true,
        scrollDelay: 600,
        scrollAnimation: 'easeOutQuad'
      },

      initialize: function($wrapper, opts) {
        if (initialized) {
          return this;
        }

        initialized = true;
        this.$wrapper = ($wrapper || this.defaults.wrapper);

        this
          .setOptions(opts)
          .build()
          .events();

        return this;
      },

      setOptions: function(opts) {
        this.options = $.extend(true, {}, this.defaults, opts, this.$wrapper.data('plugin-options'));

        return this;
      },

      build: function() {
        // Responsive Menu Events
        this.responsiveNavFixes();

        // Mega Menu
        this.megaMenu();

        // Mobile Menu Scroll to Current Item
        this.mobileMenuScroll();

        // Fix/Remove Dropdown Class if it doesn't Have Submenu
        this.fixParentItems();

        return this;
      },

      events: function() {
        var self = this;

        // Mobile Redirect - (Ignores the Dropdown from Bootstrap)
        $('.mobile-redirect').on('click', function() {
          if ($(window).width() < 991) {
            self.location = $(this).attr('href');
          }
        });

        // Anchors Position
        $('[data-hash]').on('click', function(e) {
          e.preventDefault();

          $('body').addClass('scrolling');
          var target = $(this).attr('href')
          delay = 0;

          if($(document).scrollTop() == 0) {
            $(document).scrollTop($('#header').height());
            delay = 200;
          }

          setTimeout(function() {

            if ($(window).width() < 991 && $('.nav-main-collapse').hasClass('in')) {
              //$('.nav-main-collapse').collapse('hide');
              self.scrollToTarget(target);
              return this;
            }

            self.scrollToTarget(target);

          }, 200);

          return this;
        });

        return this;
      },

      scrollToTarget: function(target) {
        var self = this,
          header = $('#header'),
          headerHeight = header.height(),
          topGap = headerHeight;

        $('html, body').animate({
          scrollTop: $(target).offset().top - topGap
        }, self.options.scrollDelay, self.options.scrollAnimation, function() {
          $('body').removeClass('scrolling');
        });

        return this;
      },

      responsiveNavFixes: function() {
        var self = this,
          addActiveClass = false;

        self.$wrapper.find('.dropdown-toggle[href]:not([href=#])').each(function() {
          $(this)
            .addClass('disabled')
            .parent()
            .prepend(
              $('<a />')
                .addClass('dropdown-toggle extra')
                .attr('href', '#')
                .append(
                  $('<i />')
                    .addClass('fa fa-angle-down')
                )
            );
        });

        self.$wrapper.find('li.dropdown > a:not(.disabled), li.dropdown-submenu > a:not(.disabled)').on('click', function(e) {

          e.preventDefault();

          if ($(window).width() > 991) {
            return this;
          }

          addActiveClass = $(this).parent().hasClass('resp-active');

          self.$wrapper.find('.resp-active').removeClass('resp-active');

          if (!addActiveClass) {
            $(this).parents('li').addClass('resp-active');
          }

          return this;

        });
      },

      megaMenu: function() {
        $(document).on('click', '.mega-menu .dropdown-menu', function(e) {
          e.stopPropagation()
        });
      },

      mobileMenuScroll: function() {
        var self = this;

        this.$wrapper.find('> li > a:not(.disabled)').on('click', function() {
          if ($(window).width() < 991 && self.options.mobileMenuScroll && !$('body').hasClass('sticky-menu-active') && !$('#header').hasClass('fixed')) {
            $('html, body').animate({
              scrollTop: $(this).offset().top
            }, 600, 'easeOutQuad');
          }
        });
      },

      fixParentItems: function() {
        if (!this.options.fixParentItems) {
          return this;
        }

        this.$wrapper.find('> li.dropdown').each(function() {
          if (!$(this).find('ul').get(0)) {
            $(this).removeClass('dropdown');
            $(this).find('.dropdown-toggle').removeClass('dropdown-toggle');
          }
        });
      }

    }

  });

}).apply(this, [window.theme, jQuery]);




/* ==========================================================================
   17. jquery.flipshow.js
   ========================================================================== */
/**
 * jquery.flipshow.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */

;( function( $, window, undefined ) {

  'use strict';

  // ======================= imagesLoaded Plugin ===============================
  // https://github.com/desandro/imagesloaded

  // $('#my-container').imagesLoaded(myFunction)
  // execute a callback when all images have loaded.
  // needed because .load() doesn't work on cached images

  // callback function gets image collection as argument
  //  this is the container

  // original: mit license. paul irish. 2010.
  // contributors: Oren Solomianik, David DeSandro, Yiannis Chatzikonstantinou

  // blank image data-uri bypasses webkit log warning (thx doug jones)
  // blank image data-uri bypasses webkit log warning (thx doug jones)
  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  $.fn.imagesLoaded = function( callback ) {
    var $this = this,
      deferred = $.isFunction($.Deferred) ? $.Deferred() : 0,
      hasNotify = $.isFunction(deferred.notify),
      $images = $this.find('img').add( $this.filter('img') ),
      loaded = [],
      proper = [],
      broken = [];

    // Register deferred callbacks
    if ($.isPlainObject(callback)) {
      $.each(callback, function (key, value) {
        if (key === 'callback') {
          callback = value;
        } else if (deferred) {
          deferred[key](value);
        }
      });
    }

    function doneLoading() {
      var $proper = $(proper),
        $broken = $(broken);

      if ( deferred ) {
        if ( broken.length ) {
          deferred.reject( $images, $proper, $broken );
        } else {
          deferred.resolve( $images );
        }
      }

      if ( $.isFunction( callback ) ) {
        callback.call( $this, $images, $proper, $broken );
      }
    }

    function imgLoadedHandler( event ) {
      imgLoaded( event.target, event.type === 'error' );
    }

    function imgLoaded( img, isBroken ) {
      // don't proceed if BLANK image, or image is already loaded
      if ( img.src === BLANK || $.inArray( img, loaded ) !== -1 ) {
        return;
      }

      // store element in loaded images array
      loaded.push( img );

      // keep track of broken and properly loaded images
      if ( isBroken ) {
        broken.push( img );
      } else {
        proper.push( img );
      }

      // cache image and its state for future calls
      $.data( img, 'imagesLoaded', { isBroken: isBroken, src: img.src } );

      // trigger deferred progress method if present
      if ( hasNotify ) {
        deferred.notifyWith( $(img), [ isBroken, $images, $(proper), $(broken) ] );
      }

      // call doneLoading and clean listeners if all images are loaded
      if ( $images.length === loaded.length ) {
        setTimeout( doneLoading );
        $images.unbind( '.imagesLoaded', imgLoadedHandler );
      }
    }

    // if no images, trigger immediately
    if ( !$images.length ) {
      doneLoading();
    } else {
      $images.bind( 'load.imagesLoaded error.imagesLoaded', imgLoadedHandler )
        .each( function( i, el ) {
          var src = el.src;

          // find out if this image has been already checked for status
          // if it was, and src has not changed, call imgLoaded on it
          var cached = $.data( el, 'imagesLoaded' );
          if ( cached && cached.src === src ) {
            imgLoaded( el, cached.isBroken );
            return;
          }

          // if complete is true and browser supports natural sizes, try
          // to check for image status manually
          if ( el.complete && el.naturalWidth !== undefined ) {
            imgLoaded( el, el.naturalWidth === 0 || el.naturalHeight === 0 );
            return;
          }

          // cached images don't fire load sometimes, so we reset src, but only when
          // dealing with IE, or image is complete (loaded) and failed manual check
          // webkit hack from http://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
          if ( el.readyState || el.complete ) {
            el.src = BLANK;
            el.src = src;
          }
        });
    }

    return deferred ? deferred.promise( $this ) : $this;
  };

  // global
  $.Flipshow = function( options, element ) {
    this.$el = $( element );
    this._init( options );
  };

  // the options
  $.Flipshow.defaults = {
    // default transition speed (ms)
    speed : 700,
    // default transition easing
    easing : 'ease-out'
  };

  $.Flipshow.prototype = {
    _init : function( options ) {

      // options
      this.options = $.extend( true, {}, $.Flipshow.defaults, options );

	var csstransitions;
	(function(s, csstransitions) {
	    csstransitions.transitions = 'transition' in s || 'WebkitTransition' in s || 'MozTransition' in s || 'msTransition' in s || 'OTransition' in s;
	})(document.createElement('div').style, csstransitions || (csstransitions = {}));

	var csstransforms3d;
	(function(s, csstransforms3d) {
	    csstransforms3d.transforms = 'transform' in s || 'WebkitTransform' in s || 'MozTransform' in s || 'msTransform' in s || 'OTransform' in s;
	})(document.createElement('div').style, csstransforms3d || (csstransforms3d = {}));

      // support for CSS Transitions & 3D transforms
      this.support = csstransitions && csstransforms3d && !(/MSIE (\d+\.\d+);/.test(navigator.userAgent));
      // transition end event name and transform name
      var transEndEventNames = {
          'WebkitTransition' : 'webkitTransitionEnd',
          'MozTransition' : 'transitionend',
          'OTransition' : 'oTransitionEnd',
          'msTransition' : 'MSTransitionEnd',
          'transition' : 'transitionend'
        },
        transformNames = {
          'WebkitTransform' : '-webkit-transform',
          'MozTransform' : '-moz-transform',
          'OTransform' : '-o-transform',
          'msTransform' : '-ms-transform',
          'transform' : 'transform'
        };

      if( this.support ) {
        this.transEndEventName = 'transitionend.cbpFWSlider';
        this.transformName = 'transform';
      }
      this.transitionProperties = this.transformName + ' ' + this.options.speed + 'ms ' + this.options.easing;

      // the list of items
      this.$listItems = this.$el.children( 'ul.fc-slides' );
      // the items
      this.$items = this.$listItems.children( 'li' ).hide();
      // total number of items
      this.itemsCount = this.$items.length;
      // current itemВґs index
      this.current = 0;
      this.$listItems.imagesLoaded( $.proxy( function() {
        // show first item
        this.$items.eq( this.current ).show();
        // add navigation and flipping structure
        if( this.itemsCount > 0 ) {
          this._addNav();
          if( this.support ) {
            this._layout();
          }
        }
      }, this ) );

    },
    _addNav : function() {

      var self = this,
        $navLeft = $( '<div class="fc-left"><span></span><span></span><span></span><i class="fa fa-arrow-left"></i></div>' ),
        $navRight = $( '<div class="fc-right"><span></span><span></span><span></span><i class="fa fa-arrow-right"></i></div>' );

      $( '<nav></nav>' ).append( $navLeft, $navRight ).appendTo( this.$el );

      $navLeft.find( 'span' ).on( 'click.flipshow touchstart.flipshow', function() {
        self._navigate( $( this ), 'left' );
      } );

      $navRight.find( 'span' ).on( 'click.flipshow touchstart.flipshow', function() {
        self._navigate( $( this ), 'right' );
      } );

    },
    _layout : function( $current, $next ) {

      this.$flipFront = $( '<div class="fc-front"><div></div></div>' );
      this.$frontContent = this.$flipFront.children( 'div:first' );
      this.$flipBack = $( '<div class="fc-back"><div></div></div>' );
      this.$backContent = this.$flipBack.children( 'div:first' );
      this.$flipEl = $( '<div class="fc-flip"></div>' ).append( this.$flipFront, this.$flipBack ).hide().appendTo( this.$el );

    },
    _navigate : function( $nav, dir ) {

      if( this.isAnimating && this.support ) {
        return false;
      }
      this.isAnimating = true;

      var $currentItem = this.$items.eq( this.current ).hide();

      if( dir === 'right' ) {
        this.current < this.itemsCount - 1 ? ++this.current : this.current = 0;
      }
      else if( dir === 'left' ) {
        this.current > 0 ? --this.current : this.current = this.itemsCount - 1;
      }

      var $nextItem = this.$items.eq( this.current );

      if( this.support ) {
        this._flip( $currentItem, $nextItem, dir, $nav.index() );
      }
      else {
        $nextItem.show();
      }

    },
    _flip : function( $currentItem, $nextItem, dir, angle ) {

      var transformProperties = '',
        // overlays
        $overlayLight = $( '<div class="fc-overlay-light"></div>' ),
        $overlayDark = $( '<div class="fc-overlay-dark"></div>' );

      this.$flipEl.css( 'transition', this.transitionProperties );

      this.$flipFront.find( 'div.fc-overlay-light, div.fc-overlay-dark' ).remove();
      this.$flipBack.find( 'div.fc-overlay-light, div.fc-overlay-dark' ).remove();

      if( dir === 'right' ) {
        this.$flipFront.append( $overlayLight );
        this.$flipBack.append( $overlayDark );
        $overlayDark.css( 'opacity', 1 );
      }
      else if( dir === 'left' ) {
        this.$flipFront.append( $overlayDark );
        this.$flipBack.append( $overlayLight );
        $overlayLight.css( 'opacity', 1 );
      }
      var overlayStyle = { transition : 'opacity ' + ( this.options.speed / 1.3 ) + 'ms' };
      $overlayLight.css( overlayStyle );
      $overlayDark.css( overlayStyle );

      switch( angle ) {
        case 0 :
          transformProperties = dir === 'left' ? 'rotate3d(-1,1,0,-179deg) rotate3d(-1,1,0,-1deg)' : 'rotate3d(1,1,0,180deg)';
          break;
        case 1 :
          transformProperties = dir === 'left' ? 'rotate3d(0,1,0,-179deg) rotate3d(0,1,0,-1deg)' : 'rotate3d(0,1,0,180deg)';
          break;
        case 2 :
          transformProperties = dir === 'left' ? 'rotate3d(1,1,0,-179deg) rotate3d(1,1,0,-1deg)' : 'rotate3d(-1,1,0,179deg) rotate3d(-1,1,0,1deg)';
          break;
      }

      this.$flipBack.css( 'transform', transformProperties );

      this.$frontContent.empty().html( $currentItem.html() );
      this.$backContent.empty().html( $nextItem.html() );
      this.$flipEl.show();

      var self = this;
      setTimeout( function() {

        self.$flipEl.css( 'transform', transformProperties );
        $overlayLight.css( 'opacity', dir === 'right' ? 1 : 0 );
        $overlayDark.css( 'opacity', dir === 'right' ? 0 : 1 );
        self.$flipEl.on( self.transEndEventName, function( event ) {
          if( event.target.className === 'fc-overlay-light' || event.target.className === 'fc-overlay-dark' ) return;
          self._ontransitionend( $nextItem );
        } );

      }, 25 );

    },
    _ontransitionend : function( $nextItem ) {
      $nextItem.show();
      this.$flipEl.off( this.transEndEventName ).css( {
        transition : 'none',
        transform : 'none'
      } ).hide();
      this.isAnimating = false;
    }
  };

  var logError = function( message ) {
    if ( window.console ) {
      window.console.error( message );
    }
  };

  $.fn.flipshow = function( options ) {
    if ( typeof options === 'string' ) {
      var args = Array.prototype.slice.call( arguments, 1 );
      this.each(function() {
        var instance = $.data( this, 'flipshow' );
        if ( !instance ) {
          logError( "cannot call methods on flipshow prior to initialization; " +
            "attempted to call method '" + options + "'" );
          return;
        }
        if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
          logError( "no such method '" + options + "' for flipshow instance" );
          return;
        }
        instance[ options ].apply( instance, args );
      });
    }
    else {
      this.each(function() {
        var instance = $.data( this, 'flipshow' );
        if ( instance ) {
          instance._init();
        }
        else {
          instance = $.data( this, 'flipshow', new $.Flipshow( options, this ) );
        }
      });
    }
    return this;
  };

} )( jQuery, window );


/* ==========================================================================
   18. view.home
   ========================================================================== */
/*
Name: 			View - Home
Written by: 	Okler Themes - (http://www.okler.net)
Version: 		3.7.0
*/


(function($) {

  'use strict';

  /*
	Circle Slider
	*/
  if ($.isFunction($.fn.flipshow)) {
    var circleContainer = $('#fcSlideshow');

    if (circleContainer.get(0)) {
      circleContainer.flipshow();

      setTimeout(function circleFlip() {
        circleContainer.data().flipshow._navigate(circleContainer.find('div.fc-right span:first'), 'right');
        setTimeout(circleFlip, 3000);
      }, 3000);
    }
  }

  /*
	Move Cloud
	*/
  if ($('.cloud').get(0)) {
    var moveCloud = function() {
      $('.cloud').animate({
        'top': '+=20px'
      }, 3000, 'linear', function() {
        $('.cloud').animate({
          'top': '-=20px'
        }, 3000, 'linear', function() {
          moveCloud();
        });
      });
    };

    moveCloud();
  }

  /*
	Nivo Slider
	*/
  if ($.isFunction($.fn.nivoSlider)) {
    $('#nivoSlider').nivoSlider({
      effect: 'random',
      slices: 15,
      boxCols: 8,
      boxRows: 4,
      animSpeed: 500,
      pauseTime: 3000,
      startSlide: 0,
      directionNav: true,
      controlNav: true,
      controlNavThumbs: false,
      pauseOnHover: true,
      manualAdvance: false,
      prevText: 'Prev',
      nextText: 'Next',
      randomStart: false
    });
  }

}).apply(this, [jQuery]);
